export default {
  translation: {
    // Added Showroom Replacements
    'showroom_unit_not_found': 'یەکەی پێشانگا نەدۆزرایەوە',
    'failed_load_showroom': 'بارکردنی زانیاری پێشانگا سەرنەکەوت',
    'failed_delete_showroom': 'سڕینەوەی پێشانگا سەرنەکەوت',
    'failed_update_status': 'نوێکردنەوەی دۆخی پێشانگا سەرنەکەوت',
    'loading_showroom_data': 'بارکردنی زانیاری پێشانگا…',
    'back_to_showrooms': 'گەڕانەوە بۆ پێشانگاکان',
    'showroom_not_found_title': 'پێشانگا نەدۆزرایەوە',
    'showroom_specifications': 'تایبەتمەندییەکانی پێشانگا',
    'confirm_delete_showroom_p1': 'ئایا دڵنیایت دەتەوێت بۆ هەمیشە بیسڕیتەوە پێشانگای ',
    'confirm_delete_showroom_p2': '؟ ئەم کردارە پاشگەزبوونەوەی بۆ نییە.',
    'configure_showroom_park': 'ڕێکخستنی کۆمپلێکسی پێشانگاکان',
    'register_new_showroom_park': 'تۆمارکردنی کۆمپلێکسێکی نوێی پێشانگاکان',
    'total_showrooms_label': 'کۆی گشتی پێشانگاکان',
    'total_showrooms_desc': 'کۆی گشتی یەکەکانی پێشانگا لەم کۆمپلێکسەدا.',
    'invalid_bulk_showroom_data': 'فۆرماتی زانیاری نەگونجاو بۆ دروستکردنی پێشانگای بەکۆمەڵ',
    'failed_create_bulk_showrooms': 'دروستکردنی پێشانگا بەکۆمەڵەکان سەرنەکەوت',
    'init_showrooms': 'دەستپێکردنی پێشانگاکان',
    'no_showrooms_in_complex': 'هێشتا هیچ یەکەیەکی پێشانگا لەم کۆمپلێکسەدا نەدۆزراوەتەوە.',
    'add_first_showroom': 'زیادکردنی یەکەم پێشانگا',
    'add_showroom_btn': 'زیادکردنی پێشانگا',
    'no_showrooms_found_title': 'هیچ پێشانگایەک نەدۆزرایەوە',
    'failed_load_showroom_data': 'بارکردنی زانیاری پێشانگا سەرنەکەوت',
    'update_showroom_desc': 'تایبەتمەندییەکانی ئەم یەکەی پێشانگایە نوێ بکەرەوە.',
    'register_showroom_desc': 'یەکەیەکی نوێی پێشانگا لەم کۆمپلێکسەدا تۆمار بکە.',
    'identity_and_location': 'شوێن و ناسنامە',
    'complex_park_name': 'ناوی کۆمپلێکس / پارك',
    'physical_address': 'ناونیشان',
    'enter_full_geographic_address': 'ناونیشانی جوگرافی تەواو بنوسە',
    'used_for_mapping': 'بەکاردێت بۆ دۆزینەوە لەسەر نەخشە و ڕاپۆرتی فەرمی',
    'capacity_and_zoning': 'توانا و ناوچە',
    'total_blocks_zones': 'کۆی بلۆکەکان / زۆنەکان',
    'how_many_blocks': 'ئەم پاركە چەند بلۆک یان ڕیزی جیاوازی هەیە؟',
    'e_g_4': 'بۆ نموونە ٤',
    'e_g_100': 'بۆ نموونە ١٠٠',
    'e_g_northside': 'بۆ نموونە: کۆمپلێکسی بازرگانی',
    'update_park': 'نوێکردنەوەی پارك',
    'save_complex': 'پاشەکەوتکردنی کۆمپلێکس',
    'location_and_identity': 'شوێن و ناسنامە',
    'specifications': 'تایبەتمەندییەکان',
    'available_count': '{{count}} بەردەستە',
    'search_by_unit': 'گەڕان بەپێی ژمارەی یەکە، زۆن، جۆر…',
    'all_types': 'هەموو جۆرەکان',
    'no_showrooms_match': 'هیچ پێشانگایەک لەگەڵ گەڕانەکەت ناگونجێت.',
    'search_showroom_units': 'گەڕان لە یەکەکانی پێشانگا، خاوەن، کرێچی...',
    'no_matching_showrooms_in_zone': 'هیچ پێشانگایەک لە زۆن {{blockNum}} نەدۆزرایەوە.',
    'search_showroom_placeholder': 'بگەڕێ بە ژمارەی یەکە، زۆن، جۆر...',
    'no_showrooms_match_search': 'هیچ پێشانگایەک لەگەڵ گەڕانەکەت ناگونجێت.',
    'clear_filters': 'پاککردنەوەی فلتەرەکان',
    'showroom_parks': 'کۆمپلێکسەکانی پێشانگا',
    'add_complex': 'کۆمپلێکسێک زیاد بکە',
    'bulk_add_showrooms': 'زیادکردنی پێشانگاکان بە کۆمەڵ',
    'avg_utilization': 'ڕێژەی بەکارهێنان',
    'rented_sold_stat': 'فرۆشراو / بەکرێدراو',
    'total_showrooms_stat': 'کۆی پێشانگاکان',
    'total_complexes': 'کۆی کۆمپلێکسەکان',
    'preferred_language': 'زمانی دڵخواز',
    'showroom_units': 'پێشانگا',



    // App
    'apartment_system': 'سیستەمی بەڕێوەبردنی پێشانگاکان',
    'apartment_management': 'بەڕێوەبردنی پێشانگاکان',
    'building_management': 'بەڕێوەبردنی کۆمپلێکسەکان',

    // Navigation - updated
    'dashboard': 'داشبۆرد',
    'user_management': 'بەڕێوەبردنی بەکارهێنەران',
    'building_management': 'بەڕێوەبردنی کۆمپلێکسەکان',
    'apartment_management': 'بەڕێوەبردنی پێشانگاکان',
    'owner_management': 'بەڕێوەبردنی خاوەنەکان',
    'tenant_management': 'بەڕێوەبردنی کرێکارەکان',
    'payment_management': 'بەڕێوەبردنی پارەدانەکان',
    'service_management': 'بەڕێوەبردنی خزمەتگوزاریەکان',
    'report_management': 'ڕاپۆرت و شیکاری',
    'log_management': 'تۆمارەکانی چالاکی',

    // Buildings
    'buildings': 'کۆمپلێکسەکان',
    'building_list': 'لیستی کۆمپلێکسەکان',
    'add_building': 'زیادکردنی کۆمپلێکس',
    'edit_building': 'دەستکاری کۆمپلێکس',
    'building_details': 'وردەکاری کۆمپلێکس',
    'building_name': 'ناوی کۆمپلێکس',
    'building_address': 'ناونیشان',
    'total_floors': 'کۆی قاتەکان',
    'total_apartments': 'کۆی پێشانگاکان',
    'building_view': 'بینینی کۆمپلێکس',
    'showing_all_apartments': 'نمایشکردنی هەموو پێشانگاکان',
    'expand_all_floors': 'کردنەوەی هەموو قاتەکان',
    'collapse_all_floors': 'داخستنی هەموو قاتەکان',

    // Apartments (renamed from Properties)
    'apartments': 'پێشانگاکان',
    'apartment_list': 'لیستی پێشانگاکان',
    'add_apartment': 'زیادکردنی پێشانگا',
    'edit_apartment': 'دەستکاری پێشانگا',
    'apartment_details': 'وردەکاری پێشانگا',
    'apartment_number': 'ژمارەی یەکە',
    'apartment_display': 'ژوورە ژمارە {{number}}',
    'floor_number': 'ژمارەی قات',
    'floor_display': 'زۆنی {{number}}',
    'zone_display': 'زۆنی {{number}}',
    'monthly_rent': 'کرێی مانگانە',
    'apartment_status': 'بار',
    'vacant': 'بەتاڵ',
    'occupied': 'گیراو',
    'under_maintenance': 'لەژێر چاککردن',

    // Services
    'services': 'خزمەتگوزاریەکان',
    'service_payments': 'پارەدانی خزمەتگوزاری',
    'generate_services': 'دروستکردنی پارەدانی خزمەتگوزاری',
    'service_statistics': 'ئاماری خزمەتگوزاری',
    'service_type': 'جۆری خزمەتگوزاری',
    'service_amount': 'بڕ',
    'service_date': 'بەرواری خزمەتگوزاری',
    'service_status': 'باری پارەدان',
    'service_paid': 'پارەدراو',
    'service_unpaid': 'پارەنەدراو',

    // Showroom Registry specific
    'showroom_registry': 'تۆماری پێشانگاکان',
    'manage_showroom_units': 'بەڕێوەبردن و چاودێریکردنی {{count}} یەکە لە هەموو کۆمپلێکسەکاندا.',
    'add_first_showroom_to_start': 'یەکەم یەکەی پێشانگای خۆت زیاد بکە بۆ دەستپێکردن.',
    'complex_park': 'کۆمپلێکس / پارك',
    'all_locations': 'هەموو شوێنەکان',
    'class_type': 'جۆری پۆل',
    'all_classes': 'هەموو پۆلەکان',
    'utilities_active': 'خزمەتگوزارییەکان کاران',
    'all_systems': 'هەموو سیستمەکان',
    'yes_powered': 'بەڵێ (کارەبا/کەشوهەوا)',
    'none': 'هیچ',
    'registry_error': 'هەڵەی تۆمار',
    'retry_connection': 'دووبارە هەوڵدانەوەی پەیوەندی',
    'empty_registry': 'تۆماری بەتاڵ',
    'no_showrooms_logged': 'هێشتا هیچ یەکەیەک لە سیستمەکەدا تۆمار نەکراوە.',
    'initialize_first_unit': 'یەکەم یەکە دروست بکە',
    'no_matches_found': 'هیچ ئەنجامێک نەدۆزرایەوە',
    'adjust_parameters_to_locate': 'پارامەترەکان بگۆڕە بۆ دۆزینەوەی یەکەکان.',
    'clear_parameters': 'پاککردنەوەی پارامەترەکان',
    'unknown_complex': 'کۆمپلێکسی نەناسراو',
    'n_a': 'نەزانراو',
    'toggle_status': 'گۆڕینی دۆخ',
    'manage': 'بەڕێوەبردن',
    'x_apartments_count': '{{count}} یەکە',
    'x_apartment_single': '١ یەکە',
    'last_updated_today': '🗓 دوایین نوێکردنەوە: ئەمڕۆ',
    'confirm_deletion_title': 'دڵنیابوونەوە لە سڕینەوە',
    'confirm_deletion_desc': 'ئایا دڵنیایت لە سڕینەوەی یەکەی "{{device}}"? ناتوانرێت ئەم کردارە گەڕێندرێتەوە.',
    'auth_failed_login_again': 'چوونەژوورەوە سەرنەکەوت. تکایە دووبارە بچۆ ژوورەوە.',
    'access_denied_admin_role': 'ڕێگەپێدان ڕەتکرایەوە. دەسەڵاتی بەڕێوەبەر پێویستە.',
    'server_error_backend_connection': 'هەڵەی سێرڤەر. تکایە پەیوەندی باکئێند بپشکنە.',
    'cannot_connect_to_server': 'ناتوانرێت پەیوەندی بە سێرڤەرەوە بکرێت. تکایە هێڵەکەت بپشکنە.',
    'failed_to_load_client_data': 'بارکردنی زانیاری کڕیار سەرکەوتوو نەبوو',
    'failed_to_load_showroom_data': 'بارکردنی زانیاری یەکە سەرنەکەوت',

    // Reports - updated
    'revenue_report': 'ڕاپۆرتی داهات',
    'payment_logs': 'تۆماری پارەدانەکان',
    'occupancy_report': 'ڕاپۆرتی گیرانی',
    'monthly_payments_report': 'ڕاپۆرتی پارەدانی مانگانە',
    'monthly_payments_subtitle': 'بینینی گشتی پارەدانی کرێکاران و خزمەتگوزاریەکان',
    'all_paid': 'هەموو پارەدراوە',
    'try_adjusting_filters': 'هەوڵبدە مانگ، ساڵ، یان فلتەرەکان بگۆڕیت',
    'pending': 'چاوەڕوان',
    'total': 'کۆی گشتی',
    'print_receipt': 'چاپکردنی وەرگرت',
    'monthly_revenue': 'داهاتی مانگانە',
    'building_revenue': 'داهاتی کۆمپلێکس',
    'owner_revenue': 'داهاتی خاوەن',
    'paid_until': 'دراوە تا',
    'tenant_payments': 'باری پارەدانی کرێکار',
    'next_billing_date': 'بەرواری پارەدانی داهاتوو',
    'next_payment': 'پارەدانی داهاتوو',
    'installment_schedule': 'خشتەی قیستەکان',
    'current_tenant': 'کرێکاری ئێستا',
    'total_owners': 'خاوەنەکان',
    'urgent_action': 'ڕێکاری بەپەلە',
    'future_tenant_upcoming': 'کرێکاری داهاتوو',

    // Logs
    'activity_logs': 'تۆماری چالاکیەکان',
    'tenant_logs': 'مێژووی کرێکارەکان',
    'revenue_by_user': 'داهات بەپێی بەکارهێنەر',
    'recent_transactions': 'مامەڵە نوێیەکان',
    'alerts_notifications': 'ئاگاداری و ئاگادارکردنەوەکان',
    'active_properties': 'عەقاراتی چالاک',
    'occupancy_rate_desc': '{{rate}}% ڕێژەی نیشتەجێبوون',
    'vs_last_month': 'بەراورد بە مانگی ڕابردوو',
    'overdue_amount': '{{amount}} دواکەوتوو',
    'payment_desc': 'پارەدانی {{type}} - پێشانگای {{number}}',
    'overdue_payments': 'پارەدانی دواکەوتوو',
    'overdue_payments_msg': '{{count}} کرێنشین پارەی هەڵپەسێردراویان هەیە بە کۆی {{amount}}',
    'view_details': 'بینینی وردەکارییەکان',
    'lease_expiring_soon': 'گرێبەست بەسەردەچێت بەم زووانە',
    'lease_expiring_msg': '{{count}} گرێبەستی بەکرێدان لە ماوەی ٣٠ ڕۆژدا بەسەردەچن',
    'review_leases': 'پێداچوونەوەی گرێبەستەکان',
    'trial_ending_soon': 'ماوەی تاقیکاری بەسەردەچێت بەم زووانە',
    'trial_ending_msg': 'ماوەی تاقیکاریت لە دوای {{days}} ڕۆژ بەسەردەچێت. تکایە بەشداری بکە بۆ ئەوەی خزمەتگوزارییەکەت نەپچڕێت.',
    'upgrade_plan': 'بەرزکردنەوەی پلان',
    'last_7_days': '٧ ڕۆژی ڕابردوو',
    'last_30_days': '٣٠ ڕۆژی ڕابردوو',
    'last_3_months': '٣ مانگی ڕابردوو',
    'last_year': 'ساڵی ڕابردوو',
    'error_loading_dashboard': 'هەڵە لە بارکردنی داشبۆرد',
    'reports_dashboard': 'داشبۆردی ڕاپۆرتەکان',
    'overview_of_financial_performance': 'تێڕوانینێکی گشتی بۆ ئەدای دارایی و ئامارەکانی عەقارات',
    'view_all_reports': 'بینینی هەموو ڕاپۆرتەکان',
    'total_revenue': 'کۆی داهات',
    'total_payments_count': '{{count}} پارەدان',
    'total_tenants': 'کۆی کرێنشینان',
    'new_tenants_this_year': '{{count}} نوێ لەم ساڵەدا',
    'total_buildings_count': '{{count}} باڵەخانە',
    'total_owners': 'کۆی خاوەن موڵکەکان',
    'ended_contracts_count': '{{count}} گرێبەستی تەواوبوو',
    'monthly_revenue_year': 'داهاتی مانگانە - {{year}}',
    'occupancy_rate': 'ڕێژەی نیشتەجێبوون',
    'quick_reports': 'ڕاپۆرتە خێراکان',
    'annual_revenue': 'داهاتی ساڵانە',
    'yearly_breakdown': 'تێڕوانینی ساڵانە بۆ هەموو داهاتەکان',
    'building_revenue': 'داهاتی باڵەخانە',
    'revenue_by_building': 'وردەکاری داهات بەپێی کۆمپلێکس',
    'owner_revenue': 'داهاتی خاوەن موڵک',
    'revenue_by_owner': 'وردەکاری داهات بەپێی خاوەن موڵک',
    'detailed_payment_history': 'مێژووی وردی پارەدان و تۆمارەکان',
    'occupied': 'تەواو بووە',
    'vacant': 'بەتاڵ',
    'maintenance': 'چاودێری',
    'excellent': 'ناوازە',
    'good': 'باش',
    'needs_improvement': 'پێویستی بە باشترکردنە',
    'rent': 'کرێ',
    'service': 'خزمەتگوزاری',
    'deposit': 'بارمتە',
    'commission': 'کۆمسیۆن',
    'insurance': 'دڵنیایی',
    'total': 'کۆی گشتی',
    'no_recent_payments': 'هیچ پارەدانێکی نوێ نەدۆزرایەوە',
    'no_overdue_payments': 'هیچ پارەدانێکی دواکەوتوو نەدۆزرایەوە',
    'overdue': 'دواکەوتوو',
    'partial': 'بەشێکی',
    'expired': 'بەسەرچوو',
    'pending': 'چاوەڕوانکراو',
    'paid': 'دراوە',
    'apt': 'پێشانگا',
    'days_overdue': 'ڕۆژ دواکەوتووە',
    'more_overdue_tenants': 'کرێنشینی تری دواکەوتوو',
    'error_fetching_occupancy': 'هەڵە لە هێنانی زانیارییەکانی نیشتەجێبوون',
    'failed_load_occupancy': 'بارکردنی ئامارەکانی نیشتەجێبوون سەرکەوتوو نەبوو',
    'error_fetching_payments': 'هەڵە لە هێنانی پارەدانە نوێیەکان',
    'failed_load_payments': 'بارکردنی پارەدانە نوێیەکان سەرکەوتوو نەبوو',
    'error_fetching_tenant_status': 'هەڵە لە هێنانی دۆخی پارەدانی کرێنشین',
    'failed_load_tenant_status': 'بارکردنی دۆخی پارەدانی کرێنشین سەرکەوتوو نەبوو',
    'failed_to_load_report_data': 'بارکردنی زانیارییەکانی ڕاپۆرت سەرکەوتوو نەبوو',

    "floor_number": "جهازی ژمارە {{number}}",
    "apartment_number": "ژوورە ژمارە {{number}}",

    // Common
    'loading': 'بارکردن...',
    'save': 'پاشەکەوت',
    'cancel': 'پاشگەزبوونەوە',
    'edit': 'دەستکاری',
    'delete': 'سڕینەوە',
    'add': 'زیادکردن',
    'view': 'بینین',
    'search': 'گەڕان',
    'filter': 'پاڵاوتن',
    'actions': 'کردارەکان',
    'status': 'بار',
    'active': 'چالاک',
    'inactive': 'نەچالاک',
    'yes': 'بەڵێ',
    'no': 'نەخێر',
    'confirm': 'دڵنیاکردنەوە',
    'success': 'سەرکەوتن',
    'error': 'هەڵە',
    'warning': 'ئاگاداری',
    'info': 'زانیاری',

    // App
    'apartment_system': 'سیستەمی پێشانگاکان',
    'apartment_management': 'بەڕێوەبردنی پێشانگاکان',

    // Authentication
    'login': 'چوونەژوورەوە',
    'logout': 'چوونەدەرەوە',
    'username': 'ناوی بەکارهێنەر',
    'password': 'وشەی نهێنی',
    'email': 'ئیمەیل',
    'remember_me': 'لەبیرم مەکە',
    'forgot_password': 'وشەی نهێنیت لەبیرچووە؟',
    'login_failed': 'چوونەژوورەوە سەرنەکەوت',
    'invalid_credentials': 'زانیاریەکان هەڵەن',

    // Navigation
    'dashboard': 'داشبۆرد',
    'core': 'سەرەکی',
    'user_management': 'بەڕێوەبردنی بەکارهێنەران',
    'property_management': 'بەڕێوەبردنی موڵک',
    'financial_management': 'بەڕێوەبردنی دارایی',
    'reports_analytics': 'ڕاپۆرت و شیکاری',
    'logs_audit': 'تۆمار و وردبینی',
    'all_activities': 'هەموو چالاکیەکان',
    'tenant_activities': 'چالاکیەکانی کرێکار',
    'system': 'سیستەم',
    'bookings': 'حیجزەکان',
    'booking_list': 'لیستی حیجزەکان',
    'new_booking': 'حیجزی نوێ',
    'booking_calendar': 'ڕۆژژمێری حیجزەکان',
    'waitlist': 'لیستی چاوەڕوانی',
    'analytics': 'شیکارییەکان',
    'subscription': 'بەشداری',
    'whatsapp': 'واتسئەپ',
    'manage_services': 'بەڕێوەبردنی خزمەتگوزارییەکان',
    'generate_payments': 'دروستکردنی پارەدانەکان',
    'reports_dashboard': 'داشبۆردی ڕاپۆرتەکان',

    // Users
    'system_users': 'بەکارهێنەرانی سیستەم',
    'user_list': 'لیستی بەکارهێنەران',
    'add_user': 'زیادکردنی بەکارهێنەر',
    'edit_user': 'دەستکاری بەکارهێنەر',
    'user_profile': 'پرۆفایلی بەکارهێنەر',
    'first_name': 'ناوی یەکەم',
    'last_name': 'ناوی کۆتایی',
    'phone_number': 'ژمارەی مۆبایل',
    'role': 'ڕۆڵ',
    'administrator': 'بەڕێوەبەر',
    'front_desk': 'پێشەوەی میز',
    'accountant': 'ژمێریار',
    'sales_role': 'فرۆشتن',
    'created_at': 'دروستکراوە لە',
    'last_login': 'کۆتا چوونەژوورەوە',
    'never': 'هەرگیز',

    // Properties
    'properties': 'موڵکەکان',
    'property_list': 'لیستی موڵک',
    'add_property': 'زیادکردنی موڵک',
    'property_owners': 'خاوەنەکانی موڵک',
    'owner_list': 'لیستی خاوەنەکان',
    'add_owner': 'زیادکردنی خاوەن',
    'owners': 'خاوەنەکان',

    // Tenants
    'tenants': 'کرێچیەکان',
    'tenant_list': 'لیستی کرێچیەکان',
    'tenant_add': 'زیادکردنی کرێچی',
    'overdue_rent': 'کرێی دواکەوتوو',

    // Tenant Detail & Lifecycle
    'search_tenants_placeholder': 'گەڕان بۆ کرێنشین بەپێی ناو، مۆبایل، یان یەکەی پێشانگا',
    'terminate_contract': 'کۆتاییهێنان بە گرێبەست',
    'terminate_confirmation_desc': 'ئایا دڵنیایت دەتەوێت کۆتایی بە گرێبەستی لۆجستی چالاکی ئەم کڕیارە بهێنیت؟ ئەم کارە دەبێتە هۆی چۆڵکردنی یەکەکە دەستبەجێ.',
    'terminating': 'کۆتایی پێ دەهێنرێت...',
    'terminate': 'کۆتایی پێ بهێنە',
    'loading_client_profile': 'بارکردنی پرۆفایلی کڕیار...',
    'profile_error': 'هەڵەی پرۆفایل',
    'client_not_found': 'کەسی کڕیار نەدۆزرایەوە.',
    'back_to_roster': 'گەڕانەوە بۆ لیست',
    'contract_ended': 'گرێبەست کۆتایی هات',
    'unit_number_display': 'یەکەی {{number}}',
    'block_number_display': '(بلۆکی {{number}})',
    'contract_information': 'زانیاری گرێبەست',
    'extend': 'درێژکردنەوە',
    'relocate': 'گواستنەوە',
    'renew_contract': 'نوێکردنەوەی گرێبەست',
    'configure': 'ڕێکخستن',
    'renter': 'کرێنشین',
    'renters': 'کرێنشینەکان',
    'showroom_unit': 'یەکەی پێشانگا',
    'complex': 'کۆمەڵگەی لۆجیستی',
    'active_unit': 'یەکەی چالاک',
    'status_override': 'گۆڕینی دۆخ',
    'force_status_change': 'گۆڕینی زۆرەملێی دۆخ',
    'complex_zoning': 'کۆمەڵگە و زۆنکردن',
    'block_zone': 'بلۆک / زۆن',
    'showroom_specifications': 'تایبەتمەندییەکانی پێشانگا',
    'class_type': 'جۆری پۆلێن',
    'internal_size': 'پانتایی ناوەوە',
    'utilities_active': 'خزمەتگوزارییە چالاکەکان',
    'owner_investor_details': 'وردەکاری خاوەن / وەبەرهێنەر',
    'entity_name': 'ناوی قەوارە',
    'contact_number': 'ژمارەی پەیوەندی',
    'future_client_upcoming': 'کڕیاری داهاتوو (لەمەودوا)',
    'active_client': 'کڕیاری چالاک',
    'contract_specs': 'تایبەتمەندییەکانی گرێبەست',
    'net_effective': 'کۆی نرخی کارا',
    'system_timestamps': 'کاتەکانی تۆمارکردنی سیستم',
    'queue_holds': 'ڕیزبەندی و حیجزەکان',
    'historical_ledger': 'تۆماری مێژوویی',
    'historical_ledger_desc': 'گرێبەستی کڕیارانی پێشوو کە پەیوەستن بەم یەکەیەوە.',
    'final_balance': 'هاوسەنگی کۆتایی',
    'archive': 'ئەرشیف',
    'notice': 'ئاگاداری',
    'try_again': 'دووبارە هەوڵ بدەرەوە',
    'back': 'گەڕانەوە',
    'showroom_not_found_desc': 'ئەو یەکەیەی کە بەدوایدا دەگەڕێیت بوونی نییە یان سڕدراوەتەوە.',
    'confirm_deletion': 'دوپاتکردنەوەی سڕینەوە',
    'delete_unit': 'سڕینەوەی یەکە',
    'unknown_complex': 'کۆمەڵگەی نەناسراو',
    'rented_sold': 'بەکراوە / فرۆشراوە',
    'contract_expired': 'گرێبەست بەسەرچووە',
    'yes_pwr_clim': 'بەڵێ (کارەبا/فێنککەرەوە)',
    'none': 'نییە',
    'view_client_profile': 'بینینی پرۆفایلی کڕیار',
    'acct_status': 'دۆخی هەژمار',
    'logged_on': 'تۆمارکراوە لە',
    'last_modification': 'دواین گۆڕانکاری',
    'log_new_hold': 'تۆمارکردنی حجزێکی نوێ',
    'view_full_queue': 'بینینی هەموو ڕیزبەندییەکە',
    'log_new_client': 'تۆمارکردنی کڕیارێکی نوێ',
    'access_client_data': 'دەستگەیشتن بە زانیاری کڕیار',
    'clear_maintenance': 'کۆتاییهێنان بە چاککردنەوە',
    'return_to_complex': 'گەڕانەوە بۆ کۆمەڵگە',
    'configure_unit': 'ڕێکخستنی یەکە',
    'critical_contract_expired': 'گرنگ: گرێبەست بەسەرچووە',
    'resolve_contract': 'چارەسەرکردنی گرێبەست',
    'entity': 'قەوارە',
    'contract_period': 'ماوەی گرێبەست',
    'payment_type_commission': 'کۆمسیۆن',
    'day': 'ڕۆژ',
    'lapsed_on': 'بەسەرچووە لە',
    'secured_by_client': 'لە ئێستادا لەلایەن کڕیارێکەوە دابینکراوە.',
    'available_for_logging': 'بەردەستە بۆ تۆمارکردن.',
    'locked_for_maintenance': 'یەکە داخراوە بۆ چاککردنەوە.',
    'no_active_queue': 'هیچ ڕیزبەندییەکی چالاک یان حجز بۆ ئەم یەکەیە نییە.',
    'contract_lapsed_desc': 'گرێبەستی لۆجستی بۆ {{name}} بەسەرچووە و پێویستی بە نوێکردنەوە یان کۆتاییهێنان هەیە.',
    'revenue_breakdown_desc': 'بینینی وردەکاری داهات بەپێی بەکارهێنەر بۆ مانگێکی دیاریکراو',
    'indefinite': 'بێ وادە',
    'contract_exceeded_desc': 'گرێبەستەکە لە کاتی کۆتایی تێپەڕیوە.',
    'command_center': 'سەنتەری کۆنترۆڵ',
    'no_historical_records': 'هیچ تۆمارێکی مێژوویی نەدۆزرایەوە.',
    'no_phone': 'مۆبایل نییە',
    'view': 'بینین',
    'base_rate': 'ڕێژەی بنەڕەتی',
    'billing_cycle': 'خولی پارەدان',
    'ledger_debt': 'قەرزی تۆمار',
    'clear_until': 'پاککراوە تا',
    'not_set': 'دیاری نەکراوە',
    'entity_profile': 'پرۆفایلی کەسایەتی',
    'active_contracts': 'گرێبەستە چالاکەکان',
    'financial_ledger': 'تۆماری دارایی',
    'entity_contacts': 'پەیوەندییەکانی کەسایەتی',
    'email_address': 'ئیمەیل',
    'primary_phone': 'مۆبایلی سەرەکی',
    'comm_language': 'زمانی پەیوەندی',
    'base_contract_details': 'وردەکارییەکانی گرێبەستی بنەڕەتی',
    'valid_window': 'ماوەی کارایی',
    'unknown_period': 'ماوەیەکی نادیار',
    'invalid_format': 'شێوازێکی نادروست',
    'invalid_data': 'داتایەکی نادروست',
    'contract_extended_success': 'گرێبەستەکە بە سەرکەوتوویی درێژکرایەوە',
    'contract_renewed_success': 'گرێبەستەکە بە سەرکەوتوویی نوێکرایەوە',
    'relocated_success': 'کۆچکردنی کڕیار بە سەرکەوتوویی ئەنجامدرا',
    'months': 'مانگ',
    'term_months': '{{count}} مانگ',
    'please_enter_valid_payment_amount': 'تکایە بڕە پارەیەکی نادروست بنووسە',
    'end_date_must_be_after_start_date': 'کاتی کۆتایی دەبێت لە دوای کاتی دەسپێک بێت',
    'failed_to_add_payment': 'زیادکردنی پارە سەرکەوتوو نەبوو',
    'failed_to_terminate_contract': 'کۆتاییهێنان بە گرێبەست سەرکەوتوو نەبوو',
    'failed_to_relocate_client': 'گواستنەوەی کڕیار سەرکەوتوو نەبوو',
    'to': 'بۆ',
    'gross_rate': 'کۆی نرخ',
    'applied_discount': 'داشکاندنی بەکارهاتوو',
    'net_effective_rate': 'کۆی نرخی کۆتایی',
    'surcharges_deposits': 'رسومات و دابینکردنەکان',
    'service_fee': 'رسوماتی خزمەتگوزاری',
    'commission': 'کۆمسیۆن',
    'sec_deposit': 'بارمتەی دڵنیایی',
    'entity_notes': 'تێبینییەکانی کەسایەتی',
    'contract_registry': 'تۆماری گرێبەستەکان',
    'logs_count': '({{count}} تۆمار)',
    'no_contracts_found': 'هیچ گرێبەستێک نەدۆزرایەوە',
    'no_contracts_desc': 'ئەم کەسایەتییە هیچ گرێبەستێکی چالاک یان مێژوویی نییە.',
    'historical_contracts': 'گرێبەستە مێژووییەکان',
    'ended': 'کۆتایی هات',
    'valid_from': 'لە بەرواری',
    'valid_to': 'بۆ بەرواری',
    'total_term': 'کۆی ماوە',
    'remaining': 'ماوە',
    'total_value': 'کۆی نرخ',
    'log_payment': 'تۆمارکردنی پارەدان',
    'months': 'مانگ',
    'expiring_soon_label': 'بەم زووانە بەسەردەچێت',
    'terminated': 'کۆتایی پێهێنراوە',
    'from': 'لە',
    'n_a': 'بەردەست نییە',
    'page': 'لاپەڕە',
    'showing_items': 'پیشاندانی {{start}}-{{end}} لە {{total}}',
    'first_page': 'لاپەڕەی یەکەم',
    'previous_page': 'لاپەڕەی پێشوو',
    'next_page': 'لاپەڕەی دواتر',
    'last_page': 'لاپەڕەی کۆتایی',
    'showing_filtered_results': 'پیشاندانی {{showing}} لە کۆی {{total}}',
    'transaction_amount': 'بڕی مامەڵە',
    'type': 'جۆر',
    'log_date': 'بەرواری تۆمار',
    'covered_period': 'ماوەی داپۆشراو',
    'ref_notes': 'ئاماژە/تێبینی',
    'no_transactions_found': 'هیچ مامەڵەیەک نەدۆزرایەوە',
    'no_transactions_desc': 'تۆماری دارایی ئەم کەسایەتییە ئێستا بەتاڵە.',
    'log_transaction': 'تۆمارکردنی مامەڵە',
    'initialize_ledger': 'دەستپێکردنی تۆمار',
    'processing_ledger': 'جارى چارەسەرکردنی تۆمار...',
    'rent': 'کرێ',
    'unknown_status': 'بارودۆخێکی نەزانراو',
    'cancel': 'پاشگەزبوونەوە',
    'renew_logistics_contract': 'نوێکردنەوەی گرێبەستی لۆجستی',
    'allocated_unit': 'یەکەی تەرخانکراو',
    'select_target_unit': 'یەکەی مەبەست هەڵبژێرە...',
    'current_unit': 'یەکەی ئێستا',
    'new_base_rate': 'نرخی نوێی سەرەکی',
    'billing_cycle_start': 'دەستپێکی خولی پارەدان',
    'finalize_renewal': 'کۆتاییهێنان بە نوێکردنەوە',
    'relocate_client_unit': 'گواستنەوەی یەکەی کڕیار',
    'current_allocation': 'تەرخانکردنی ئێستا',
    'select_target_slot': 'شوێنی مەبەست هەڵبژێرە...',
    'confirm_relocation': 'دڵنیابوونەوە لە گواستنەوە',
    'processing': 'لە پرۆسەدایە...',
    'extend_contract': 'درێژکردنەوەی گرێبەست',
    'current_end_date': 'کۆتا بەرواری ئێستا',
    'new_end_date': 'کۆتا بەرواری نوێ',
    'confirm_extension': 'دڵنیابوونەوە لە درێژکردنەوە',
    'finalize_transaction': 'ناردنی تۆمار',
    'extending_contract': 'درێژکردنەوەی گرێبەست...',
    'preferred_language': 'زمانی پەسەندکراو',
    "works_at_showroom": "کار دەکات لە پێشانگا",
    'english': 'ئینگلیزی',
    'arabic': 'عەرەبی',
    'kurdish': 'کوردی',
    'tenant_notes_placeholder': 'تێبینی بۆ ئەم کرێنشینە بنووسە...',

    // Payments
    'payments': 'پارەدانەکان',
    'all_payments': 'هەموو پارەدانەکان',
    'record_payment': 'تۆمارکردنی پارەدان',
    'overdue_payments': 'پارەدانەکان درەنگکراوەکان',
    'receipts': 'وەرگرتەکان',

    // Reports
    'reports': 'ڕاپۆرتەکان',
    'all_reports': 'هەموو ڕاپۆرتەکان',
    'financial_reports': 'ڕاپۆرتە داراییەکان',
    'payment_reports': 'ڕاپۆرتە پارەدانەکان',
    'property_reports': 'ڕاپۆرتە موڵکەکان',

    // Settings
    'settings': 'ڕێکخستنەکان',
    'profile_settings': 'ڕێکخستنەکانی پرۆفایل',
    'system_settings': 'ڕێکخستنەکانی سیستەم',
    'profile': 'پرۆفایل',
    'personal_details': 'وردەکارییە کەسییەکان',
    'security_settings': 'ڕێکخستنەکانی ئاسایش',
    'change_password': 'گۆڕینی وشەی نهێنی',
    'current_password': 'وشەی نهێنی ئێستا',
    'new_password': 'وشەی نهێنی نوێ',
    'confirm_new_password': 'دڵنیابوونەوە لە وشەی نهێنی نوێ',
    'organization_settings': 'ڕێکخستنەکانی ڕێکخراو',
    'organization_name': 'ناوی ڕێکخراو',
    'timezone': 'کاتژمێری ناوچەکە',
    'subscription_plan': 'پلانی بەشداری',
    'trial_period': 'ماوەی تاقیکردنەوە',
    'days_left': '{{days}} ڕۆژ ماوە',
    'update_profile_success': 'پرۆفایل بە سەرکەوتوویی نوێکرایەوە',
    'update_password_success': 'وشەی نهێنی بە سەرکەوتوویی گۆڕدرا',
    'update_system_success': 'ڕێکخستنەکانی سیستەم بە سەرکەوتوویی نوێکرایەوە',

    // Notifications
    'notifications': 'ئاگاداریەکان',
    'view_all_notifications': 'بینینی هەموو ئاگاداریەکان',

    // Forms
    'personal_information': 'زانیاری کەسی',
    'account_information': 'زانیاری هەژمار',
    'security': 'ئاسایش',
    'enter_first_name': 'ناوی یەکەم بنوسە',
    'enter_last_name': 'ناوی کۆتایی بنوسە',
    'enter_email': 'ئیمەیل بنوسە',
    'enter_username': 'ناوی بەکارهێنەر بنوسە',
    'enter_password': 'وشەی نهێنی بنوسە',
    'enter_phone_number': 'ژمارەی مۆبایل بنوسە',
    'confirm_password': 'دڵنیابوونەوە لە وشەی نهێنی',
    'leave_blank_to_keep_current': 'بەتاڵی بەجێبهێڵە بۆ پاراستنی وشەی نهێنی ئێستا',

    // Validation
    'first_name_required': 'ناوی یەکەم پێویستە',
    'last_name_required': 'ناوی کۆتایی پێویستە',
    'email_required': 'ئیمەیل پێویستە',
    'invalid_email': 'تکایە ئیمەیلی دروست بنوسە',
    'username_required': 'ناوی بەکارهێنەر پێویستە',
    'username_too_short': 'ناوی بەکارهێنەر دەبێت لانی کەم ٣ پیت بێت',
    'password_required': 'وشەی نهێنی پێویستە',
    'password_too_short': 'وشەی نهێنی دەبێت لانی کەم ٦ پیت بێت',
    'passwords_do_not_match': 'وشەی نهێنیەکان یەک ناگرێتەوە',
    'phone_invalid_format': 'تکایە ژمارەی مۆبایلی دروست بنوسە',

    // Actions
    'saving': 'پاشەکەوت دەکرێت...',
    'deleting': 'سڕینەوە دەکرێت...',
    'loading_users': 'بارکردنی بەکارهێنەران...',
    'loading_user_data': 'بارکردنی زانیاری بەکارهێنەر...',
    'update': 'نوێکردنەوە',
    'activate': 'چالاککردن',
    'deactivate': 'ناچالاککردن',
    'show_all': 'نیشانی هەموو',
    'hide_inactive': 'شاردنەوەی نەچالاک',
    'all_roles': 'هەموو ڕۆڵەکان',
    'retry': 'هەوڵدانەوە',

    // Messages
    'no_users_found': 'هیچ بەکارهێنەرێک نەدۆزرایەوە',
    'user_created_successfully': 'بەکارهێنەر بە سەرکەوتوویی دروستکرا',
    'user_updated_successfully': 'بەکارهێنەر بە سەرکەوتوویی نوێکرایەوە',
    'user_deleted_successfully': 'بەکارهێنەر بە سەرکەوتوویی سڕایەوە',
    'confirm_deletion': 'دڵنیابوونەوە لە سڕینەوە',
    'delete_user_confirmation': 'ئایا دڵنیایت لە سڕینەوەی {{name}}? ئەم کردارە ناتوانرێت گەڕێندرێتەوە.',

    // Dashboard
    'welcome_back': 'بەخێربێیتەوە',
    'dashboard_subtitle': 'لێرە دەبینیت چی ڕوودەدات لەگەڵ موڵکەکانتدا ئەمڕۆ.',
    'total_properties': 'کۆی گشتی موڵک',
    'active_tenants': 'کرێکارە چالاکەکان',
    'monthly_revenue': 'داھاتی مانگانە',
    'pending_payments': 'پارەدانە چاوەڕوانکراوەکان',
    'recent_activity': 'چالاکیەکانی دوایی',
    'quick_actions': 'کردارە خێراکان',
    'showing': 'پیشاندان',
    'of': 'لە',
    'users': 'بەکارهێنەران',
    'contact': 'پەیوەندی',
    'user': 'بەکارهێنەر',

    // Sidebar specific translations
    'core': 'سەرەکی',
    'user_management': 'بەڕێوەبردنی بەکارهێنەران',
    'property_management': 'بەڕێوەبردنی موڵک',
    'financial_management': 'بەڕێوەبردنی دارایی',
    'reports_analytics': 'ڕاپۆرت و شیکاری',
    'logs_audit': 'تۆمار و پشکنین',
    'system': 'سیستەم',

    'system_users': 'بەکارهێنەرانی سیستەم',
    'user_list': 'لیستی بەکارهێنەران',
    'add_user': 'زیادکردنی بەکارهێنەر',

    'buildings': 'کۆمپلێکسەکان',
    'building_list': 'لیستی کۆمپلێکسەکان',
    'add_building': 'زیادکردنی کۆمپلێکس',

    'apartments': 'پێشانگاکان',
    'apartment_list': 'لیستی پێشانگاکان',
    'add_apartment': 'زیادکردنی پێشانگا',

    'owners': 'خاوەنەکان',
    'owner_list': 'لیستی خاوەنەکان',
    'add_owner': 'زیادکردنی خاوەن',

    'tenants': 'کرێکارەکان',
    'tenant_list': 'لیستی کرێکارەکان',
    'tenant_add': 'زیادکردنی کرێکار',
    'owner_living': 'نیشتەجێبوونی خاوەن',
    'future_tenant': 'کرێکاری داهاتوو',
    'overdue_rent': 'کرێی درەنگکراو',

    'payments': 'پارەدانەکان',
    'all_payments': 'هەموو پارەدانەکان',
    'record_payment': 'تۆمارکردنی پارەدان',
    'payment_stats': 'ئاماری پارەدان',

    'service_payments': 'پارەدانی خزمەتگوزاری',
    'manage_services': 'بەڕێوەبردنی خزمەتگوزاری',
    'generate_payments': 'دروستکردنی پارەدان',
    'service_statistics': 'ئاماری خزمەتگوزاری',

    'reports': 'ڕاپۆرتەکان',
    'reports_dashboard': 'داشبۆردی ڕاپۆرتەکان',
    'revenue_report': 'ڕاپۆرتی داهات',
    'payment_logs': 'تۆماری پارەدانەکان',
    'occupancy_report': 'ڕاپۆرتی گیرانی',
    'tenant_payments': 'پارەدانی کرێکارەکان',
    'building_revenue': 'داهاتی کۆمپلێکس',
    'owner_revenue': 'داهاتی خاوەن',

    'activity_logs': 'تۆماری چالاکیەکان',
    'all_activities': 'هەموو چالاکیەکان',
    'tenant_activities': 'چالاکیەکانی کرێکار',
    'monthly_revenue': 'داهاتی مانگانە',

    'settings': 'ڕێکخستنەکان',
    'profile_settings': 'ڕێکخستنەکانی پرۆفایل',
    'system_settings': 'ڕێکخستنەکانی سیستەم',

    'logout': 'چوونەدەرەوە',

    // Apartment Detail View
    'loading_apartment_details': 'وردەکاری پێشانگا بار دەکرێت...',
    'error_loading_apartment': 'هەڵە لە بارکردنی وردەکاری پێشانگا',
    'try_again': 'هەوڵبدەرەوە',
    'back_to_apartments': 'گەڕانەوە بۆ پێشانگاکان',
    'apartment_not_found': 'پێشانگا نەدۆزرایەوە',
    'apartment_not_found_message': 'پێشانگاکە کە بۆی دەگەڕێی بوونی نییە یان سڕایەوە.',

    'building_and_location': 'کۆمپلێکس و شوێن',
    'building': 'کۆمپلێکس',
    'floor': 'قات',
    'address': 'ناونیشان',

    'apartment_details': 'وردەکاری پێشانگا',
    'apartment_type': 'جۆر',
    'size': 'قەبارە',
    'furnished': 'بە خزمەتگوزاری',

    'owner_information': 'زانیاری خاوەن',
    'owner_name': 'ناو',
    'owner_contact': 'پەیوەندی',

    'additional_information': 'زانیاری زیاتر',
    'created_at': 'دروستکراوە لە',
    'updated_at': 'دوایین نوێکردنەوە',

    'status_management': 'بەڕێوەبردنی بار',
    'status_vacant': 'بەتاڵ',
    'status_occupied': 'گیراو',
    'status_maintenance': 'لەژێر چاککردن',
    'status_vacant_description': 'بەردەستە بۆ کرێ یان خراپە',
    'status_occupied_description': 'لەلایەن کرێکارەوە گیراوە',
    'status_maintenance_description': 'لەژێر چاککردن یان نوێکردنەوە',
    'change_status': 'گۆڕینی بار بۆ',

    'quick_actions': 'کردارە خێراکان',
    'create_lease': 'دروستکردنی گرێبەست',
    'view_tenant_info': 'بینینی زانیاری کرێکار',
    'mark_maintenance_complete': 'نیشانەکردنی چاککردن وەک تەواو',
    'view_building': 'بینینی کۆمپلێکس',
    'edit_apartment': 'دەستکاری پێشانگا',

    'same_building_apartments': 'هەمان کۆمپلێکس',
    'view_all_apartments_in_building': 'بینینی هەموو پێشانگاکانی کۆمپلێکس',
    'view_vacant_apartments': 'بینینی پێشانگا بەتاڵەکان',

    // Delete confirmation
    'delete_apartment_confirmation': 'ئایا دڵنیایت لە سڕینەوەی پێشانگای "{{name}}"? ناتوانرێت ئەم کردارە گەڕێندرێتەوە.',

    // Apartment Form
    'loading_apartment_data': 'بارکردنی زانیاری پێشانگا...',
    'edit_apartment': 'دەستکاری پێشانگا',
    'add_new_apartment': 'زیادکردنی پێشانگای نوێ',

    'basic_information': 'زانیاری بنەڕەتی',
    'apartment_number': 'ژمارەی یەکە',
    'enter_apartment_number': 'ژمارەی پێشانگا بنوسە',
    'floor_number': 'ژمارەی قات',
    'enter_floor_number': 'ژمارەی قات بنوسە',
    'size_sqm': 'قەبارە (م²)',
    'enter_size': 'قەبارە بنوسە بە مەتر چوارگۆشە',
    'apartment_type': 'جۆری پێشانگا',
    'select_apartment_type': 'جۆری پێشانگا هەڵبژێرە',
    'select_building': 'کۆمپلێکس هەڵبژێرە',
    'furnished': 'بە خزمەتگوزاری',

    // Validation messages
    'floor_required': 'ڕیز/بەش پێویستە',
    'row_section': 'ڕیز / بەش',
    'enter_row_section': 'ژمارەی ڕیز یان بەش بنوسە',
    'apartment_number_required': 'ژمارەی پێشانگا پێویستە',
    'size_required': 'قەبارە پێویستە',
    'type_required': 'جۆری پێشانگا پێویستە',
    'building_required': 'کۆمپلێکس پێویستە',
    'invalid_size': 'قەبارە دەبێت گەورەتر بێت لە صفر',

    // Form actions
    'update': 'نوێکردنەوە',
    'save': 'پاشەکەوت',
    'saving': 'پاشەکەوت دەکرێت...',


    // Apartment List
    'apartments': 'پێشانگاکان',
    'search_apartments': 'گەڕان بۆ پێشانگا...',
    'filter': 'پاڵاوتن',
    'grid_view': 'تۆڕ',
    'list_view': 'لیست',
    'add_apartment': 'زیادکردنی پێشانگا',
    'all_buildings': 'هەموو کۆمپلێکسەکان',
    'all_types': 'هەموو جۆرەکان',
    'all_statuses': 'هەموو بارەکان',
    'all': 'هەمووی',
    'vacant_apartments': 'پێشانگا بەتاڵەکان',
    'occupied_apartments': 'پێشانگا گیراوەکان',
    'maintenance_apartments': 'لەژێر چاککردن',
    'loading_apartments': 'پێشانگاکان بار دەکرێن...',
    'error_loading_apartments': 'هەڵە لە بارکردنی پێشانگاکان',
    'no_apartments_found': 'هیچ پێشانگایەک نەدۆزرایەوە',
    'no_apartments_message': 'هیچ پێشانگایەک لە سیستەمەکە نییە تاکو ئێستا.',
    'create_first_apartment': 'دروستکردنی یەکەم پێشانگا',
    'showing_filtered_results': 'پیشاندانی {{showing}} لە {{total}} پێشانگا',

    // Statuses
    'vacant': 'بەتاڵ',
    'occupied': 'گیراو',
    'maintenance': 'لەژێر چاککردن',

    // Apartment card
    'furnished': 'بە خزمەتگوزاری',

    // Delete confirmation
    'delete_apartment_confirmation': 'ئایا دڵنیایت لە سڕینەوەی پێشانگای "{{name}}"? ناتوانرێت ئەم کردارە گەڕێندرێتەوە.',
    'deleting': 'سڕینەوە دەکرێت...',


    // Bulk Apartment Creator
    'bulk_apartment_creation': 'دروستکردنی پێشانگاکان بە کۆمەڵ',
    'preview': 'پێشبینین',
    'apartment_number_format': 'شێوازی ژمارەی پێشانگاکان',
    'format_pattern': 'شێوازی فۆرمات',
    'format_pattern_help': 'بەکارهێنانی {floor} بۆ ژمارەی قات و {unit} بۆ ژمارەی یەکە. نموونە: {floor}{unit} = 0201',
    'preview_example': 'نموونەی پێشبینین',
    'floor_plans': 'پلانی قاتەکان',
    'add_floor_plan': 'زیادکردنی پلانی قات',
    'floor_plan_number': 'پلانی قاتی {number}',
    'floors_comma_separated': 'قاتەکان (بە فاریزە جیاکراوە)',
    'unit_types': 'جۆرەکانی یەکە',
    'add_unit_type': 'زیادکردنی جۆری یەکە',
    'unit_type_number': 'جۆری یەکە {number}',
    'name': 'ناو',
    'quantity': 'ژمارە',
    'type': 'جۆر',
    'area_sqm': 'قەبارە (م²)',
    'furnished': 'بە خزمەتگوزاری',
    'apartment_preview_count': 'پێشبینینی پێشانگاکان ({count} یەکە)',
    'floor_unit_type': 'قاتی {floor} • {type}',
    'close': 'داخستن',
    'create_apartments': 'دروستکردنی پێشانگاکان',
    'create_apartments_count': 'دروستکردنی {count} پێشانگا',
    'creating_apartments': 'دروستکردنی یەکەی کەلەپووری...',
    'add_at_least_one_floor_plan': 'تکایە بەلایەنی کەم یەک پلانی قات زیاد بکە',
    'no_apartments_to_create': 'هیچ یەکەی کەلەپووریەک نییە بۆ دروستکردن',


    'building_name_required': 'ناوی کۆمپلێکس پێویستە',
    'building_address_required': 'ناونیشانی کۆمپلێکس پێویستە',
    'invalid_floors': 'پێویستە کۆی قاتەکان کەمتر نەبێت لە ١',
    'invalid_apartments': 'پێویستە کۆی پێشانگاکان کەمتر نەبێت لە ٠',
    'loading_building_data': 'زانیارییەکانی کۆمپلێکس بار دەکرێت...',
    'edit_building': 'دەستکاریکردنی کۆمپلێکس',
    'add_new_building': 'کۆمپلێکسێکی نوێ زیاد بکە',
    'basic_information': 'زانیارییە بنەڕەتییەکان',
    'building_name': 'ناوی کۆمپلێکس',
    'enter_building_name': 'ناوی کۆمپلێکس بنوسە',
    'total_floors': 'کۆی قاتەکان',
    'number_of_floors': 'ژمارەی قاتەکان',
    'total_apartments': 'کۆی پێشانگاکان',
    'number_of_apartments': 'ژمارەی پێشانگاکان',
    'address': 'ناونیشان',
    'enter_complete_building_address': 'ناونیشانی تەواوی کۆمپلێکس بنوسە',
    'cancel': 'پاشگەزبوونەوە',
    'saving': 'لە پاشەکەوتکردندایە...',
    'update': 'نوێکردنەوە',
    'save': 'پاشەکەوتکردن',


    'buildings': 'کۆمپلێکسەکان',
    'search_buildings': 'گەڕان بەناو کۆمپلێکسەکاندا...',
    'bulk_add_apartments': 'زیادکردنی پێشانگا بە گشتی',
    'bulk_add': 'زیادکردنی گشتی',
    'total_buildings': 'کۆی کۆمپلێکسەکان',
    'avg_occupancy': 'ناوەندەی پڕبوون',
    'add_building': 'کۆمپلێکسێک زیاد بکە',
    'loading_buildings': 'کۆمپلێکسەکان بار دەکرێن...',
    'error_loading_buildings': 'هەڕە لە بارکردنی کۆمپلێکسەکان',
    'try_again': 'هەوڵبدەرەوە',
    'no_buildings_found': 'هیچ کۆمپلێکسێک نەدۆزرایەوە',
    'no_buildings_yet': 'هێشتا کۆمپلێکسێک نییە',
    'no_buildings_match_search': 'هیچ کۆمپلێکسێک نەدۆزرایەوە کە بگونجێت لەگەڵ "{{search}}"',
    'no_buildings_message': 'هێشتا هیچ کۆمپلێکسێک نییە لە سیستمەکەدا. یەکەم کۆمپلێکست زیاد بکە بۆ دەستپێکردن.',
    'create_first_building': 'یەکەم کۆمپلێکس دروست بکە',
    'showing_filtered_results': 'پیشاندانی {{showing}} لە {{total}} کۆمپلێکسەکان',
    'floors': 'قاتەکان',
    'levels': 'قاتەکان',
    'no_inventory_data': 'هێشتا یەکەیەک نییە',
    'init_units': 'یەکە زیاد بکە',
    'apartments': 'پێشانگاکان',
    'occupancy': 'پڕی',
    'vacant': 'بەتاڵ',
    'occupied': 'پڕە',
    'no_apartments_yet': 'هێشتا پێشانگا نییە',
    'add_apartments': '+ زیادکردنی پێشانگا',
    'confirm_deletion': 'دڵنیابوونەوە لە سڕینەوە',
    'delete_building_confirmation': 'دڵنیایت لە سڕینەوەی کۆمپلێکسی "{{name}}"? ناتوانیت ئەم کارە بگەڕێنیتەوە.',
    'cancel': 'پاشگەزبوونەوە',
    'deleting': 'لە سڕینەوەدایە...',
    'delete': 'سڕینەوە',
    'create_building_first': 'تکایە یەکەم کۆمپلێکست دروست بکە',
    'create': 'دروستکردنی پێشانگا',
    'unnamed_building': 'کۆمپلێکسی بێ ناو',
    'no_address_provided': 'ناونیشان نەدراوە',

    'select_building_for_bulk_creation': 'کۆمپلێکس هەڵبژێرە بۆ زیادکردنی پێشانگا بە گشتی',

    'loading_building_details': 'زانیارییەکانی کۆمپلێکس بار دەکرێت...',
    'error_loading_building': 'هەڵە لە بارکردنی کۆمپلێکس',
    'try_again': 'هەوڵبدەرەوە',
    'back_to_buildings': 'گەڕانەوە بۆ کۆمپلێکسەکان',
    'building_not_found': 'کۆمپلێکس نەدۆزرایەوە',
    'building_not_found_message': 'کۆمپلێکسکە کە بۆی دەگەڕێی بوونی نییە یان سڕایەوە.',
    'add_apartment': 'پێشانگایەک زیاد بکە',
    'edit_building': 'دەستکاریکردنی کۆمپلێکس',
    'generate_reports': 'ڕاپۆرت دروست بکە',
    'total_apartments': 'کۆی پێشانگاکان',
    'units': 'یەکە',
    'across_floors': 'بەدرێژایی {{floors}} قاتە',
    'vacant_apartments': 'بەتاڵ',
    'available_for_rent': 'بۆ کرێ بەردەستە',
    'no_vacancies': 'هیچ پێشانگایەک بەتاڵ نییە',
    'occupancy_rate': 'ڕێژەی پڕی',
    'occupied_units': 'یەکەی پڕ',
    'maintenance_apartments': 'چاککردن',
    'needs_attention': 'پێویستی بە سەرنجە',
    'average_apartment_size': 'ناوەندەی قەبارە',
    'furnished_apartments': 'بە خزمەتگوزاری',
    'utility_status': 'دۆخی خزمەتگوزاریەکان',
    'water': 'ئاو',
    'electricity': 'کارەبا',
    'internet': 'ئینتەرنێت',
    'hide_details': 'شاردنەوەی زانیاری',
    'show_details': 'پیشاندانی زانیاری',
    'search_apartments': 'گەڕان بۆ پێشانگا، خاوەن، کرێکار...',
    'all_statuses': 'هەموو دۆخەکان',
    'vacant': 'بەتاڵ',
    'occupied': 'پڕە',
    'maintenance': 'چاککردن',
    'top_floor_first': 'قاتی سەرەوە یەکەم',
    'ground_floor_first': 'قاتی خوارەوە یەکەم',
    'showing_results': 'پیشاندانی {{count}} لە {{total}} پێشانگا',
    'matching': 'گونجاندن',
    'with_status': 'بە دۆخی',
    'no_apartments_found': 'هیچ پێشانگایەک نەدۆزرایەوە',
    'no_apartments_match_filters': 'هیچ پێشانگایەک نەدۆزرایەوە کە گونجاو بیت لەگەڵ فلتەرەکانی ئێستا.',
    'clear_filters': 'پاککردنەوەی فلتەرەکان',
    'floor_number': 'قاتی {{number}}',
    'apartments': 'پێشانگا',
    'owner': 'خاوەن',
    'status': 'دۆخ',
    'vacant_status': 'بەردەستە',
    'maintenance_status': 'لەژێر چاککردندا',
    'furnished': 'بە خزمەتگوزاری',
    'unfurnished': 'بێ خزمەتگوزاری',
    'no_matching_apartments_on_floor': 'هیچ پێشانگایەک لە قاتی {{floor}} نەدۆزرایەوە کە گونجاو بیت لەگەڵ فلتەرەکانی ئێستا.',
    'construction_year': 'ساڵی دروستکردن: {{year}}',

    'activity_logs': 'تۆمارەکانی چالاکی',
    'track_all_system_activities': 'بەدواداچوونی هەموو چالاکی و گۆڕانکارییەکانی سیستم',
    'filter': 'فلتەر',
    'export_to_excel': 'هەناردن بۆ ئێکسێل',
    'exporting': 'لە هەنارداندایە...',
    'filter_logs': 'فلتەرکردنی تۆمارەکان',
    'action_type': 'جۆری کردار',
    'all_actions': 'هەموو کردارەکان',
    'entity_type': 'جۆری ناوک',
    'all_entities': 'هەموو ناوکەکان',
    'entries_per_page': 'ژمارەی تۆمار بۆ هەر پەڕەیەک',
    'start_date': 'بەرواری دەستپێکردن',
    'end_date': 'بەرواری کۆتایی',
    'reset': 'دووبارەکردنەوە',
    'apply_filter': 'جێبەجێکردنی فلتەر',
    'previous': 'پێشوو',
    'next': 'دواتر',
    'tenant_activity_logs': 'تۆمارەکانی چالاکی کرێکاران',
    'payment_activity_logs': 'تۆمارەکانی چالاکی پارەدانەکان',
    'building_activity_logs': 'تۆمارەکانی چالاکی کۆمپلێکسەکان',
    'apartment_activity_logs': 'تۆمارەکانی چالاکی پێشانگاکان',
    'owner_activity_logs': 'تۆمارەکانی چالاکی خاوەنەکان',
    'user_activity_logs': 'تۆمارەکانی چالاکی بەکارهێنەران',
    'system_activity_logs': 'تۆمارەکانی چالاکی سیستم',

    'monthly_revenue_by_user': 'داھاتمانگەی مانگانە بەپێی بەکارهێنەر',
    'export_to_excel': 'هەناردن بۆ ئێکسێل',
    'exporting': 'لە هەنارداندایە...',
    'total_revenue': 'کۆی داھات',
    'total_payments': 'کۆی پارەدانەکان',
    'recorded_by': 'تۆمارکراوە لەلایەن',
    'average_payment': 'ناوەندی پارەدان',
    'per_transaction': 'بۆ هەر مامەڵەیەک',
    'revenue_by_user': 'داھات بەپێی بەکارهێنەر',
    'no_revenue_data': 'هیچ زانیاری داھات نییە',
    'no_revenue_data_message': 'هیچ تۆمارێکی پارەدان نەدۆزرایەوە بۆ {{month}} {{year}}. هەوڵبدە مانگ یان ساڵێکی جیاواز هەڵبژێریت.',

    'loading_owner_data': 'زانیارییەکانی خاوەن بار دەکرێت...',
    'error_loading_owner': 'هەڵە لە بارکردنی خاوەن',
    'back_to_owners': 'گەڕانەوە بۆ خاوەنەکان',
    'send_reminder': 'ناردنی ئاگادارکردنەوە',
    'edit': 'دەستکاری',
    'overview': 'بینینێکی گشتی',
    'properties': 'پێشانگاکان',
    'payments': 'پارەدانەکان',
    'outstanding': 'قەرزەکان',
    'contact_information': 'زانیارییەکانی پەیوەندی',
    'property_overview': 'بینینێکی گشتی لە پێشانگاکان',
    'add_apartment': 'پێشانگایەک زیاد بکە',
    'no_properties': 'هیچ پێشانگایەک نییە',
    'no_properties_message': 'ئەم خاوەنە هیچ پێشانگایەکی نییە تاکو ئێستا.',
    'add_first_property': 'یەکەم پێشانگا زیاد بکە',
    'view_details': 'بینینی وردەکاری',
    'payment_history': 'مێژووی پارەدانەکان',
    'no_payments': 'هیچ پارەدانێک نییە',
    'no_payments_message': 'تا ئێستا هیچ پارەدانێک تۆمار نەکراوە.',
    'outstanding_fees': 'پارەی قەرزکراو',
    'no_outstanding_fees': 'هیچ پارەی قەرزکراو نییە',
    'all_fees_paid': 'هەموو پارەکان نوێکراوەتەوە.',
    'total_outstanding': 'کۆی پارەی قەرزکراو',
    'add_payment': 'پارەدان زیاد بکە',
    'property': 'پێشانگا',
    'select_property': 'پێشانگا هەڵبژێرە',
    'amount': 'بڕی پارە',
    'payment_date': 'بەرواری پارەدان',
    'payment_method': 'شێوازی پارەدان',
    'cash': 'پارە',
    'bank_transfer': 'گوازینەوەی بانکی',
    'check': 'چێک',
    'credit_card': 'کارتی بانکی',
    'online_payment': 'پارەدانی ئۆنلاین',
    'reference_number': 'ژمارەی سەرچاوە',
    'notes': 'تێبینییەکان',
    'cancel': 'پاشگەزبوونەوە',


    'owner_information': 'زانیارییەکانی خاوەن',
    'name': 'ناو',
    'phone': 'ژمارەی مۆبایل',
    'owner_lives_property': 'خاوەن لە پێشانگاکە دەژی',
    'select_apartments': 'پێشانگاکان هەڵبژێرە',
    'available_apartments': 'پێشانگای بەردەست',
    'no_apartments_available': 'هیچ پێشانگایەک بەردەست نییە. هەموو پێشانگاکان خاوەنیان هەیە.',
    'apartment_number': 'پێشانگای ژمارە {{number}}',
    'floor': 'قات',
    'size': 'قەبارە',
    'type': 'جۆر',
    'status': 'دۆخ',
    'cancel': 'پاشگەزبوونەوە',
    'saving': 'لە پاشەکەوتکردندایە...',
    'update_owner': 'نوێکردنەوەی خاوەن',
    'create_owner': 'دروستکردنی خاوەن',
    'edit_property_owner': 'دەستکاریکردنی خاوەنی پێشانگا',
    'add_property_owner': 'زیادکردنی خاوەنی پێشانگا',


    'property_owners': 'خاوەن موڵک',
    'add_owner': 'خاوەن زیاد بکە',
    'search_owners': 'گەڕان بۆ خاوەنەکان...',
    'filter': 'پاڵاوتن',
    'list_view': 'لیست',
    'grid_view': 'تۆڕ',
    'export': 'هەناردن',
    'exporting': 'هەناردن...',
    'living_status': 'دۆخی نیشتەجێبوون',
    'all': 'هەمووی',
    'living_on_property': 'نیشتەجێبوون لە موڵک',
    'not_living_on_property': 'نەنیشتەجێبوون لە موڵک',
    'country': 'وڵات',
    'all_countries': 'هەموو وڵاتەکان',
    'apartment_status': 'دۆخی پێشانگا',
    'all_statuses': 'هەموو دۆخەکان',
    'with_vacant': 'بە پێشانگای بەتاڵ',
    'fully_occupied': 'تەواو داگیرکراو',
    'with_maintenance': 'بە چاککردنەوە',
    'min_apartments': 'کەمترین پێشانگا',
    'max_apartments': 'زۆرترین پێشانگا',
    'min_occupancy_rate': 'کەمترین ڕێژەی داگیرکردن (%)',
    'clear_filters': 'پاککردنەوەی پاڵاوتن',
    'apply_filters': 'جێبەجێکردنی پاڵاوتن',
    'total_owners': 'کۆی گشتی خاوەنەکان',
    'resident_owners': 'خاوەنە نیشتەجێبووەکان',
    'with_apartments': 'بە پێشانگا',
    'without_apartments': 'بێ پێشانگا',
    'loading_owners': 'بارکردنی خاوەنەکان...',
    'error_loading_owners': 'هەڵە لە بارکردنی خاوەنەکان',
    'try_again': 'هەوڵبدەرەوە',
    'no_owners_found': 'هیچ خاوەنی موڵک نەدۆزرایەوە',
    'no_owners_message': 'هیچ خاوەنی موڵک نییە لە سیستمەکەدا. کرتە لەسەر دوگمەی \'خاوەن زیاد بکە\' بۆ دروستکردنی یەکەم خاوەن.',
    'create_first_owner': 'یەکەم خاوەن دروست بکە',
    'showing_filtered_results': 'پیشاندانی {showing} لە {total} خاوەن',
    'confirm_deletion': 'دڵنیابوونەوە لە سڕینەوە',
    'delete_owner_confirmation': 'دڵنیایت دەتەوێت خاوەن "{name}" بسڕیتەوە؟ ناتوانیت ئەم کردارە بگەڕێنیتەوە.',
    'cancel': 'پاشگەزبوونەوە',
    'delete': 'سڕینەوە',
    'deleting': 'سڕینەوە...',
    "loading": "باركردن...",
    "edit_property_owner": "دەستکاری خاوەنی موڵک",
    "add_property_owner": "زیادکردنی خاوەنی موڵک",
    "owner_information": "زانیاری خاوەن",
    "name": "ناو",
    "phone": "ژمارەی تەلەفۆن",
    "owner_lives_on_property": "لەوێ کار دەکات",
    "select_apartments": "هەڵبژاردنی پێشانگا ({{count}})",
    "available_apartments": "{{count}} پێشانگای بەردەست",
    "no_apartments_available": "هیچ پێشانگایەک بەردەست نییە. هەموو پێشانگاکان خاوەنیان هەیە.",
    "floor": "قات",
    "size": "قەبارە",
    "size_unit_sqm": "م²",
    "type": "جۆر",
    "status": "دۆخ",
    "cancel": "هەڵوەشاندنەوە",
    "saving": "پاشەکەوتکردن...",
    "update_owner": "نوێکردنەوەی خاوەن",
    "create_owner": "دروستکردنی خاوەن",
    "failed_to_load_data": "سەرکەوتوو نەبوو لە بارکردنی زانیارییەکان",
    "failed_to_save_owner": "سەرکەوتوو نەبوو لە پاشەکەوتکردنی خاوەن",

    "activity_logs": "تۆماری چالاکییەکان",
    "tenant_activity_logs": "تۆماری چالاکی کرێچییەکان",
    "payment_activity_logs": "تۆماری چالاکی پارەدانەکان",
    "building_activity_logs": "تۆماری چالاکی کۆمپلێکسەکان",
    "apartment_activity_logs": "تۆماری چالاکی شوققەکان",
    "owner_activity_logs": "تۆماری چالاکی خاوەنەکان",
    "user_activity_logs": "تۆماری چالاکی بەکارهێنەران",
    "system_activity_logs": "تۆماری چالاکی سیستەم",
    "track_all_system_activities": "بەدواداچوونی هەموو چالاکی و گۆڕانکارییەکانی سیستەم",
    "filter": "فلتەر",
    "export_to_excel": "هەناردەکردن بۆ ئێکسێل",
    "exporting": "خەریکی هەناردەکردنە...",
    "search_logs_placeholder": "گەڕان لە تۆمارەکان بەپێی ناو، بەکارهێنەر یان وردەکاری...",
    "showing_entries": "پیشاندانی {{showing}} لە {{total}} تۆمار",
    "filter_logs": "فلتەرکردنی تۆمارەکان",
    "action_type": "جۆری کردار",
    "all_actions": "هەموو کردارەکان",
    "entity_type": "جۆری ڕەگەز",
    "all_entities": "هەموو ڕەگەزەکان",
    "entries_per_page": "تۆمار لە هەر لاپەڕەیەک",
    "start_date": "بەرواری دەستپێک",
    "end_date": "بەرواری کۆتایی",
    "reset": "ڕێکخستنەوە",
    "apply_filter": "جێبەجێکردنی فلتەر",
    "time": "کات",
    "user": "بەکارهێنەر",
    "action": "کردار",
    "entity": "ڕەگەز",
    "details": "وردەکاری",
    "view": "بینین",
    "system": "سیستەم",
    "view_entity_details": "بینینی وردەکاری {{type}}",
    "no_logs_matching_search": "هیچ تۆمارێکی چالاکی نییە کە لەگەڵ هۆکارەکانی گەڕاندا بگونجێت",
    "no_logs_for_filters": "هیچ تۆمارێکی چالاکی نییە بۆ فلتەرە دیاریکراوەکان",
    "showing_range": "پیشاندانی {{start}} بۆ {{end}} لە {{total}} تۆمار",
    "previous": "پێشوو",
    "next": "داهاتوو",
    "failed_to_load_logs": "بارکردنی تۆماری چالاکییەکان سەرکەوتوو نەبوو",
    "failed_to_export_logs": "هەناردەکردنی تۆمارەکان بۆ ئێکسێل سەرکەوتوو نەبوو",

    "tenant": "کرێچی",
    "payment": "پارەدان",
    "building": "کۆمپلێکس",
    "apartment": "شوققە",
    "owner": "خاوەن",
    "user": "بەکارهێنەر",
    "system": "سیستەم",

    "created": "دروستکرا",
    "updated": "نوێکرایەوە",
    "deleted": "سڕایەوە",
    "viewed": "بینرا",
    "login": "چوونەژوورەوە",
    "logout": "چوونەدەرەوە",
    "payment_made": "پارەدان کرا",
    "payment_received": "پارەدان وەرگیرا",
    "status_changed": "دۆخ گۆڕدرا",
    "approved": "پەسەندکرا",
    "rejected": "ڕەتکرایەوە",
    "maintenance_request": "داواکاری چاککردنەوە",
    "maintenance_completed": "چاککردنەوە تەواو بوو",


    "loading_payment_data": "باركردنی زانیاری پارەدان...",
    "error_loading_payment": "هەڵە لە باركردنی پارەدان",
    "payment_not_found": "پارەدان نەدۆزرایەوە",
    "back_to_payments": "گەڕانەوە بۆ پارەدانەکان",
    "confirm_deletion": "دڵنیابوونەوە لە سڕینەوە",
    "delete_payment_confirmation": "دڵنیایت لە سڕینەوەی ئەم پارەدانە بە بڕی {{amount}}؟ ئەم کردارە ناتوانرێت بگەڕێنرێتەوە.",
    "cancel": "هەڵوەشاندنەوە",
    "deleting": "سڕینەوە...",
    "delete": "سڕینەوە",
    "print_receipt": "چاپکردنی پسوولە",
    "edit": "دەستکاریکردن",
    "tenant": "کرێچی",
    "unknown_tenant": "کرێچی نەناسراو",
    "apartment": "پێشانگا",
    "apt": "پێشانگا",
    "none": "هیچ",
    "payment_period": "ماوەی پارەدان",
    "payment_details": "وردەکاریەکانی پارەدان",
    "tenant_information": "زانیاری کرێچی",
    "payment_information": "زانیاری پارەدان",
    "amount": "بڕ",
    "payment_date": "بەرواری پارەدان",
    "payment_type": "جۆری پارەدان",
    "created": "دروستکراوە",
    "last_updated": "دوایین نوێکردنەوە",
    "notes": "تێبینیەکان",
    "view_tenant": "بینینی کرێچی",
    "unknown_period": "ماوەی نەناسراو",
    "to": "بۆ",
    "invalid_period_data": "زانیاری ماوە نادروستە",
    "unknown_type": "جۆری نەناسراو",
    "unknown": "نەناسراو",
    "failed_to_load_payment_data": "سەرکەوتوو نەبوو لە باركردنی زانیاری پارەدان",
    "failed_to_delete_payment": "سەرکەوتوو نەبوو لە سڕینەوەی پارەدان",

    "rent": "کرێ",
    "service": "ڕسوماتی خزمەتگوزاری",
    "deposit": "بارمتە",
    "maintenance": "چاککردنەوە",
    "other": "هیتر",

    "loading": "باركردن...",
    "edit_payment": "دەستکاری پارەدان",
    "record_payment": "تۆمارکردنی پارەدان",
    "payment_information": "زانیاری پارەدان",
    "tenant": "کرێچی",
    "select_tenant": "کرێچی هەڵبژێرە",
    "apt": "پێشانگا",
    "no_apartment": "پێشانگا نییە",
    "amount": "بڕ",
    "payment_date": "بەرواری پارەدان",
    "payment_type": "جۆری پارەدان",
    "payment_period": "ماوەی پارەدان",
    "period_start": "دەستپێکی ماوە",
    "period_end": "کۆتایی ماوە",
    "additional_information": "زانیاری زیاتر",
    "notes": "تێبینییەکان",
    "notes_placeholder": "هەر تێبینییەکی زیاتر سەبارەت بەم پارەدانە...",
    "cancel": "هەڵوەشاندنەوە",
    "saving": "پاشەکەوتکردن...",
    "update_payment": "نوێکردنەوەی پارەدان",
    "failed_to_load_tenants_format": "بارکردنی کرێچییەکان سەرکەوتوو نەبوو: فۆرماتی داتا چاوەڕواننەکراو",
    "failed_to_load_tenants": "بارکردنی کرێچییەکان سەرکەوتوو نەبوو. تکایە دووبارە هەوڵ بدەوە.",
    "failed_to_load_payment_data": "بارکردنی زانیاری پارەدان سەرکەوتوو نەبوو",
    "failed_to_save_payment": "پاشەکەوتکردنی پارەدان سەرکەوتوو نەبوو",

    "rent": "کرێ",
    "service": "ڕسوماتی خزمەتگوزاری",
    "deposit": "بارمتە",
    "maintenance": "چاککردنەوە",
    "other": "هیتر",

    "payments": "پارەدانەکان",
    "refresh": "نوێکردنەوە",
    "refresh_payments": "نوێکردنەوەی پارەدانەکان",
    "stats": "ئامار",
    "toggle_statistics": "گۆڕینی بینینی ئامارەکان",
    "search_payments": "گەڕان لە پارەدانەکان...",
    "filter": "پاڵاوتن",
    "record_payment": "تۆمارکردنی پارەدان",
    "confirm_deletion": "دڵنیاکردنەوە لە سڕینەوە",
    "confirm_delete_payment": "ئایا دڵنیایت لە سڕینەوەی پارەدانی {amount} بۆ کرێگر {tenantName}؟ ناتوانیت ئەم کردارە بگەڕێنیتەوە.",
    "cancel": "پاشگەزبوونەوە",
    "deleting": "لە سڕینەوەدایە...",
    "delete": "سڕینەوە",
    "filter_payments": "پاڵاوتنی پارەدانەکان",
    "reset_all": "ڕێکخستنەوەی هەموو",
    "payment_type": "جۆری پارەدان",
    "all_types": "هەموو جۆرەکان",
    "payment_type_rent": "کرێ",
    "payment_type_service": "خزمەتگوزاری",
    "payment_type_deposit": "دانهێنان",
    "payment_type_other": "ئەویتر",
    "building": "بینین",
    "all_buildings": "هەموو کۆمپلێکسەکان",
    "from_date": "لە رۆژی",
    "to_date": "بۆ رۆژی",
    "total_payments": "کۆی گشتی پارەدانەکان",
    "payment": "پارەدان",
    "payments": "پارەدانەکان",
    "recorded": "تۆمارکراو",
    "rent_payments": "پارەدانی کرێ",
    "service_payments": "پارەدانی خزمەتگوزاری",
    "payment_statistics": "ئاماری پارەدانەکان",
    "payments_by_month": "پارەدانەکان بەپێی مانگ",
    "payment_types_distribution": "دابەشبوونی جۆرەکانی پارەدان",
    "recent_activity": "چالاکیەکانی دوایی",
    "close_statistics": "داخستنی ئامارەکان",
    "loading_payments": "بارکردنی پارەدانەکان...",
    "this_may_take_moment": "لەوانەیە کاتێکی کەم بخایەنێت",
    "error_loading_payments": "هەڵە لە بارکردنی پارەدانەکان",
    "try_again": "هەوڵبدەرەوە",
    "no_payments_found": "هیچ پارەدانێک نەدۆزرایەوە",
    "no_payments_match_filters": "هیچ پارەدانێک نەگونجاوە لەگەڵ پاڵاوتنی ئێستا. هەوڵبدە پاڵاوتنی گونجاوتر بکەیت.",
    "no_payments_in_system": "هیچ پارەدانێک نییە لە سیستەمەکەدا. دەستپێبکە بە تۆمارکردنی یەکەم پارەدان.",
    "reset_filters": "ڕێکخستنەوەی پاڵاوتنەکان",
    "record_first_payment": "تۆمارکردنی یەکەم پارەدان",
    "unknown_period": "ماوەی نەزانراو",
    "to": "بۆ",
    "invalid_period_data": "داتای ماوەی نادروست",
    "unknown_type": "جۆری نەزانراو",
    "apt": "یەکەی کەلەپووری",
    "print_receipt": "چاپکردنی پێداویستی",
    "view_details": "بینینی وردەکاری",
    "edit_payment": "دەستکاری پارەدان",
    "delete_payment": "سڕینەوەی پارەدان",
    "showing_payments": "نیشاندانی {start}-{end} لە {total} پارەدانەکان",
    "showing_filtered_payments": "نیشاندانی {filtered} لە {total} پارەدانەکان بەپێی گەڕانەکەت",
    "authentication_required": "پێویستی بە ڕاستکردنەوەی ناسنامە هەیە",
    "failed_load_payments": "سەرکەوتوو نەبوو لە بارکردنی داتای پارەدانەکان",
    "auth_failed_login_again": "ڕاستکردنەوەی ناسنامە سەرکەوتوو نەبوو. تکایە جارێکی تر بچۆ ژوورەوە.",
    "access_denied_admin_required": "ڕێگەپێنەدراو. پێویستی بە ڕۆڵی بەڕێوەبەر هەیە.",
    "server_error_check_backend": "هەڵەی ڕاژەکار. تکایە بزانە ئایا ڕاژەکار کاردەکات.",
    "cannot_connect_server": "ناتوانیت پەیوەندی بە ڕاژەکارەوە بکەیت. تکایە بزانە ئایا ڕاژەکار کاردەکات.",
    "error_fetching_payments": "هەڵە لە هێنانی پارەدانەکان",
    "error_deleting_payment": "هەڵە لە سڕینەوەی پارەدان",
    "failed_delete_payment": "سەرکەوتوو نەبوو لە سڕینەوەی پارەدان",

    "occupancy_report": "ڕاپۆرتی ئەشغاڵی",
    "loading": "بارکردن...",
    "refresh": "نوێکردنەوە",
    "back": "گەڕانەوە",
    "error_fetching_occupancy": "هەڵە لە هێنانی داتای ئەشغاڵی",
    "failed_load_occupancy": "سەرکەوتوو نەبوو لە بارکردنی داتای ئەشغاڵی",
    "occupied": "پڕ",
    "vacant": "بەتاڵ",
    "maintenance": "چاککردن",
    "apartments": "یەکەی کەلەپووری",
    "occupancy_rate": "ڕێژەی ئەشغاڵی",
    "of": "لە",
    "vacant_apartments": "یەکەی کەلەپووریە بەتاڵەکان",
    "of_total": "لە کۆی گشتی",
    "maintenance_apartments": "لە چاککردندا",
    "potential_income": "داهاتی مانگانەی ئەگەری",
    "buildings": "کۆمپلێکسەکان",
    "occupancy_distribution": "دابەشبوونی ئەشغاڵی",
    "occupancy_by_building": "ئەشغاڵی بەپێی کۆمپلێکس",
    "building": "کۆمپلێکس",
    "total_apartments": "کۆی یەکەکانی کەلەپووری",
    "print_report": "چاپکردنی ڕاپۆرت",
    "export_report": "هەناردنی ڕاپۆرت",

    "rent": "کرێ",
    "service": "خزمەتگوزاری",
    "commission": "کومیسیۆن",
    "insurance": "دڵنیایی",
    "total": "کۆی گشتی",

    "occupied": "پڕ",
    "vacant": "بەتاڵ",
    "maintenance": "چاککردن",
    "apartments": "یەکەی کەلەپووری",
    "of": "لە",
    "excellent": "نایاب",
    "good": "باش",
    "needs_improvement": "پێویستی بە باشترکردن هەیە",
    "error_fetching_occupancy": "هەڵە لە هێنانی داتای ئەشغاڵی",
    "failed_load_occupancy": "سەرکەوتوو نەبوو لە بارکردنی داتای ئەشغاڵی",

    "overdue": "دواکەوتوو",
    "pending": "چاوەڕوان",
    "paid": "پارەدراو",
    "no_overdue_payments": "هیچ پارەدانێکی دواکەوتوو نەدۆزرایەوە",
    "apt": "یەکەی کەلەپووری",
    "days_overdue": "رۆژ دواکەوتوو",
    "more_overdue_tenants": "کرێگرانی دواکەوتووی زیاتر...",
    "error_fetching_tenant_status": "هەڵە لە هێنانی دۆخی پارەدانی کرێگر",
    "failed_load_tenant_status": "سەرکەوتوو نەبوو لە بارکردنی دۆخی پارەدانی کرێگر",

    "rent": "کرێ",
    "service": "خزمەتگوزاری",
    "deposit": "دانهێنان",
    "no_recent_payments": "هیچ پارەدانێکی نوێ نەدۆزرایەوە",
    "error_fetching_payments": "هەڵە لە هێنانی پارەدانە نوێیەکان",
    "failed_load_payments": "سەرکەوتوو نەبوو لە بارکردنی پارەدانە نوێیەکان",

    "payment_logs": "تۆماری پارەدانەکان",
    "filter": "فلتەر",
    "back": "گەڕانەوە",
    "search_payment_logs_placeholder": "گەڕان لە تۆماری پارەدانەکان...",
    "showing_entries": "پیشاندانی {{showing}} لە {{total}} تۆمار",
    "filter_payments": "فلتەری پارەدانەکان",
    "time_period": "ماوەی کات",
    "start_date": "بەرواری دەستپێک",
    "end_date": "بەرواری کۆتایی",
    "payment_type": "جۆری پارەدان",
    "all_types": "هەموو جۆرەکان",
    "entries_per_page": "تۆمار لە هەر لاپەڕەیەک",
    "reset": "ڕێکخستنەوە",
    "apply_filter": "جێبەجێکردنی فلتەر",
    "payment_id": "ناسنامەی پارەدان",
    "date": "بەروار",
    "tenant": "کرێچی",
    "building": "کۆمپلێکس",
    "type": "جۆر",
    "amount": "بڕ",
    "actions": "کردارەکان",
    "print_receipt": "چاپکردنی پسوولە",
    "view_details": "بینینی وردەکاری",
    "no_logs_matching_search": "هیچ تۆمارێکی پارەدان نییە کە لەگەڵ هۆکارەکانی گەڕاندا بگونجێت",
    "no_logs_for_period": "هیچ تۆمارێکی پارەدان بەردەست نییە بۆ ماوەی کاتی دیاریکراو",
    "showing_range": "پیشاندانی {{start}} بۆ {{end}} لە {{total}} تۆمار",
    "previous": "پێشوو",
    "next": "داهاتوو",
    "print_report": "چاپکردنی ڕاپۆرت",
    "export_to_excel": "هەناردەکردن بۆ ئێکسێل",
    "failed_to_load_payment_logs": "بارکردنی تۆماری پارەدانەکان سەرکەوتوو نەبوو",

    "current_month": "مانگی ئێستا",
    "last_month": "مانگی پێشوو",
    "current_quarter": "چارەکی ئێستا",
    "current_year": "ساڵی ئێستا",
    "custom": "ماوەی تایبەت",

    "rent": "کرێ",
    "service": "خزمەتگوزاری",
    "commission": "کومیشن",
    "insurance": "بیمە",
    "other": "هیتر",

    "reports_dashboard": "داشبۆردی ڕاپۆرتەکان",
    "overview_of_financial_performance": "تێڕوانینی گشتی کارایی دارایی و ئاماری موڵک",
    "view_all_reports": "بینینی هەموو ڕاپۆرتەکان",
    "failed_to_load_report_data": "بارکردنی داتای ڕاپۆرت سەرکەوتوو نەبوو",
    "total_revenue": "کۆی داهات",
    "total_payments_count": "{{count}} پارەدان",
    "total_tenants": "کۆی کرێچییەکان",
    "new_tenants_this_year": "{{count}} نوێ لەم ساڵدا",
    "total_properties": "کۆی موڵکەکان",
    "total_buildings_count": "{{count}} کۆمپلێکس",
    "total_owners": "کۆی خاوەنەکان",
    "ended_contracts_count": "{{count}} گرێبەستی کۆتاییهاتوو",
    "monthly_revenue_year": "داهاتی مانگانە - {{year}}",
    "view_details": "بینینی وردەکاری",
    "occupancy_rate": "ڕێژەی داگیرکردن",
    "recent_payments": "پارەدانە نوێیەکان",
    "view_all": "بینینی هەموو",
    "overdue_payments": "پارەدانە دواکەوتووەکان",
    "quick_reports": "ڕاپۆرتە خێراکان",
    "annual_revenue": "داهاتی سالانە",
    "yearly_breakdown": "شیکردنەوەی ساڵانەی هەموو داهاتەکان",
    "building_revenue": "داهاتی کۆمپلێکس",
    "revenue_by_building": "شیکردنەوەی داهات بەپێی کۆمپلێکس",
    "owner_revenue": "داهاتی خاوەن",
    "revenue_by_owner": "شیکردنەوەی داهات بەپێی خاوەنی موڵک",
    "payment_logs": "تۆماری پارەدانەکان",
    "detailed_payment_history": "مێژووی وردی پارەدان",


    "revenue_report": "ڕاپۆرتی داهات",
    "filter": "فلتەر",
    "loading": "باركردن...",
    "refresh": "نوێکردنەوە",
    "back": "گەڕانەوە",
    "filter_report": "فلتەری ڕاپۆرت",
    "time_period": "ماوەی کات",
    "start_date": "بەرواری دەستپێک",
    "end_date": "بەرواری کۆتایی",
    "cancel": "هەڵوەشاندنەوە",
    "apply_filter": "جێبەجێکردنی فلتەر",
    "failed_to_load_revenue_data": "بارکردنی داتای داهات سەرکەوتوو نەبوو",
    "total_revenue": "کۆی داهات",
    "total_payments_count": "{{count}} پارەدان",
    "rent_revenue": "داهاتی کرێ",
    "percent_of_total": "{{percent}}% لە کۆی گشتی",
    "service_revenue": "داهاتی خزمەتگوزاری",
    "unique_tenants": "کرێچییە تایبەتەکان",
    "avg_per_tenant": "ناوەندی {{amount}} بۆ هەر کرێچییەک",
    "revenue_by_building": "داهات بەپێی کۆمپلێکس",
    "view_details": "بینینی وردەکاری",
    "building": "کۆمپلێکس",
    "tenants": "کرێچییەکان",
    "no_building_revenue_data": "هیچ داتای داهاتی کۆمپلێکس بەردەست نییە",
    "revenue_by_owner": "داهات بەپێی خاوەن",
    "owner": "خاوەن",
    "apartments": "پێشانگاکان",
    "no_owner_revenue_data": "هیچ داتای داهاتی خاوەن بەردەست نییە",
    "print_report": "چاپکردنی ڕاپۆرت",
    "export_report": "هەناردەکردنی ڕاپۆرت",

    "current_month": "مانگی ئێستا",
    "last_month": "مانگی پێشوو",
    "current_quarter": "چارەکی ئێستا",
    "current_year": "ساڵی ئێستا",
    "custom": "ماوەی تایبەت",

    "service_payments_management": "بەڕێوەبردنی پارەدانی خزمەتگوزاریەکان",
    "refresh": "نوێکردنەوە",
    "back_to_dashboard": "گەڕانەوە بۆ داشبۆرد",
    "building": "کۆمپلێکس",
    "select_building": "هەڵبژاردنی کۆمپلێکس",
    "year": "ساڵ",
    "search": "گەڕان",
    "search_apartments_tenants": "گەڕان بۆ پێشانگا، کرێچییەکان...",
    "generate_payments": "دروستکردنی پارەدانەکان",
    "view_statistics": "بینینی ئامارەکان",
    "filter_by_status": "فلتەر بەپێی دۆخ",
    "all": "هەموو",
    "paid": "پارەدراو",
    "unpaid": "پارەنەدراو",
    "clear_filters": "سڕینەوەی فلتەرەکان",
    "loading_service_data": "بارکردنی داتای پارەدانی خزمەتگوزاری...",
    "no_building_selected": "هیچ کۆمپلێکسێک هەڵنەبژێردراوە",
    "please_select_building": "تکایە کۆمپلێکسێک هەڵبژێرە بۆ بینینی پارەدانی خزمەتگوزاریەکان.",
    "no_search_results": "هیچ ئەنجامێکی گەڕان نییە",
    "no_matching_apartments": "هیچ پێشانگا یان کرێچییەک نییە کە لەگەڵ پێوەرەکانی گەڕاندا بگونجێت.",
    "service_payments_for_building_year": "پارەدانی خزمەتگوزاری بۆ {{building}} - {{year}}",
    "floor_number": "قاتی {{number}}",
    "apartments": "پێشانگاکان",
    "rate": "ڕێژە",
    "tenant_owner": "کرێچی/خاوەن",
    "vacant": "بەتاڵ",
    "mark_as_paid": "نیشانە بکە وەک پارەدراو",
    "mark_as_unpaid": "نیشانە بکە وەک پارەنەدراو",
    "view_details": "بینینی وردەکاری",
    "summary": "کورتە",
    "floor_apartment_count": "{{floors}} زۆن، {{apartments}} پێشانگا",
    "zone_showroom_count": "{{zones}} زۆن، {{showrooms}} پێشانگا",
    "no_floors_available": "هیچ قاتێک بەردەست نییە",
    "no_floors_message": "هیچ قاتێک بە پێشانگا لەم کۆمپلێکسیەدا نییە، یان هێشتا هیچ پارەدانێکی خزمەتگوزاری دروست نەکراوە.",
    "failed_to_load_buildings": "بارکردنی کۆمپلێکسەکان سەرکەوتوو نەبوو. تکایە دووبارە هەوڵ بدەوە.",
    "failed_to_load_floors": "بارکردنی قاتەکان سەرکەوتوو نەبوو",
    "failed_to_load_building_floors": "بارکردنی قاتەکانی کۆمپلێکس سەرکەوتوو نەبوو",
    "failed_to_load_floor_data": "بارکردنی داتای قات سەرکەوتوو نەبوو",
    "data_refreshed_successfully": "داتا بە سەرکەوتوویی نوێکرایەوە.",
    "failed_to_refresh_data": "نوێکردنەوەی داتا سەرکەوتوو نەبوو",
    "marked_as_paid_via_service_management": "نیشانە کرا وەک پارەدراو لە ڕێگەی بەڕێوەبردنی خزمەتگوزارییەوە",
    "marked_as_unpaid_via_service_management": "نیشانە کرا وەک پارەنەدراو لە ڕێگەی بەڕێوەبردنی خزمەتگوزارییەوە",
    "payment_marked_as_paid": "پارەدان بە سەرکەوتوویی نیشانە کرا وەک پارەدراو.",
    "payment_marked_as_unpaid": "پارەدان بە سەرکەوتوویی نیشانە کرا وەک پارەنەدراو.",
    "failed_to_update_payment": "نوێکردنەوەی پارەدان سەرکەوتوو نەبوو",
    "payment_details": "وردەکاری پارەدان",
    "payment_due": "پارەدانی بەسەرچوو",
    "amount": "بڕ",
    "status": "دۆخ",
    "paid_on": "پارەدراو لە",
    "no_apartments_on_floor": "هیچ پێشانگایەک لەم قاتەدا نەدۆزرایەوە.",

    "month_1": "کانوونی دووەم",
    "month_2": "شوبات",
    "month_3": "ئازار",
    "month_4": "نیسان",
    "month_5": "ئایار",
    "month_6": "حوزەیران",
    "month_7": "تەمموز",
    "month_8": "ئاب",
    "month_9": "ئەیلوول",
    "month_10": "تشرینی یەکەم",
    "month_11": "تشرینی دووەم",
    "month_12": "کانوونی یەکەم",

    "service_payment_details": "وردەکاری پارەدانی خزمەتگوزاری",
    "print_receipt": "چاپکردنی پسوولە",
    "loading": "باركردن...",
    "failed_to_load_payment_details": "بارکردنی وردەکاری پارەدان سەرکەوتوو نەبوو",
    "api_endpoint_missing_message": "ئەم هەڵەیە ئاماژە بە کۆتایی API ونبوو لەسەر سێرڤەری باکگراوند دەکات. بۆ چاککردنی، ڕێگایەک زیاد بکە بۆ GET /api/services/:id لە فایلی serviceRoutes.js.",
    "payment_information": "زانیاری پارەدان",
    "apartment": "پێشانگا",
    "period": "ماوە",
    "amount": "بڕ",
    "status": "دۆخ",
    "tenant": "کرێچی",
    "owner": "خاوەن",
    "payment_date": "بەرواری پارەدان",
    "paid_by": "پارەدراو لەلایەن",
    "notes": "تێبینییەکان",
    "update_payment": "نوێکردنەوەی پارەدان",
    "mark_as_paid": "نیشانە بکە وەک پارەدراو",
    "currency": "دراو",
    "select_payer": "دانەر هەڵبژێرە",
    "management": "بەڕێوەبردن",
    "other": "هیتر",
    "payment_notes_placeholder": "هەر تێبینییەکی زیاتر سەبارەت بەم پارەدانە دابنێ...",
    "cancel": "هەڵوەشاندنەوە",
    "saving": "پاشەکەوتکردن...",
    "payment_history": "مێژووی پارەدان",
    "date": "بەروار",
    "action": "کردار",
    "by": "لەلایەن",
    "paid": "پارەدراو",
    "unpaid": "پارەنەدراو",
    "payment_marked_as_paid": "پارەدان بە سەرکەوتوویی نیشانە کرا وەک پارەدراو.",
    "payment_marked_as_unpaid": "پارەدان بە سەرکەوتوویی نیشانە کرا وەک پارەنەدراو.",
    "failed_to_update_payment": "نوێکردنەوەی پارەدان سەرکەوتوو نەبوو",
    "service_payment_receipt": "پسوولەی پارەدانی خزمەتگوزاری",
    "property_management": "بەڕێوەبردنی موڵک",
    "receipt_generated": "ئەم پسوولەیە دروستکرا لە {{date}} کاتژمێر {{time}}",
    "automated_receipt_notice": "ئەمە پسوولەیەکی دروستکراوی خۆکارە و پێویستی بە واژۆ نییە.",
    "us_dollar": "دۆلاری ئەمەریکی",
    "iraqi_dinar": "دیناری عێراقی",
    "euro": "یۆرۆ",

    "month_1": "کانوونی دووەم",
    "month_2": "شوبات",
    "month_3": "ئازار",
    "month_4": "نیسان",
    "month_5": "ئایار",
    "month_6": "حوزەیران",
    "month_7": "تەمموز",
    "month_8": "ئاب",
    "month_9": "ئەیلوول",
    "month_10": "تشرینی یەکەم",
    "month_11": "تشرینی دووەم",
    "month_12": "کانوونی یەکەم",

    "tenant": "کرێچی",
    "owner": "خاوەن",
    "management": "بەڕێوەبردن",
    "other": "هیتر",

    "generate_service_payments": "دروستکردنی پارەدانەکانی خزمەتگوزاری",
    "recipients": "وەرگرەکان",
    "entire_building": "هەموو باڵەخانەکە",
    "generate_for_all_apartments": "دروستکردن بۆ هەموو پێشانگاکان لە باڵەخانەکەدا",
    "specific_tenants": "کرێچییە دیاریکراوەکان",
    "generate_for_selected_tenants": "دروستکردن تەنها بۆ کرێچییە دیاریکراوەکان",
    "specific_owners": "خاوەنە دیاریکراوەکان",
    "generate_for_selected_owners": "دروستکردن تەنها بۆ خاوەنە دیاریکراوەکان",
    "select_building": "باڵەخانە هەڵبژێرە",
    "include_vacant_apartments": "پێشانگا بەتاڵەکان لەخۆبگرە",
    "selected_tenants": "کرێچییە دیاریکراوەکان",
    "selected_owners": "خاوەنە دیاریکراوەکان",
    "select_tenants": "کرێچییەکان هەڵبژێرە",
    "select_owners": "خاوەنەکان هەڵبژێرە",
    "no_tenants_selected": "هیچ کرێچییەک دیاری نەکراوە",
    "no_owners_selected": "هیچ خاوەنێک دیاری نەکراوە",
    "payment_details": "وردەکاریەکانی پارەدان",
    "amount": "بڕ",
    "currency": "دراو",
    "us_dollar": "دۆلاری ئەمەریکی",
    "iraqi_dinar": "دیناری عێراقی",
    "euro": "یۆرۆ",
    "initial_status": "دۆخی سەرەتایی",
    "unpaid": "نەدراوە",
    "paid": "دراوە",
    "notes": "تێبینیەکان",
    "payment_notes_placeholder": "هەر تێبینیەکی زیادەت هەیە لەسەر ئەم پارەدانانە بینووسە...",
    "time_period": "ماوەی کات",
    "generation_type": "جۆری دروستکردن",
    "single_month": "یەک مانگ",
    "multiple_months": "چەندین مانگ",
    "month_range": "مەودای مانگەکان",
    "year": "ساڵ",
    "month": "مانگ",
    "select_months": "مانگەکان هەڵبژێرە",
    "from": "لە",
    "to": "بۆ",
    "selected_months": "مانگە دیاریکراوەکان",
    "payment_generation_summary": "پوختەی دروستکردنی پارەدان",
    "all_apartments_in": "هەموو پێشانگاکان لە",
    "selected_building": "باڵەخانەی دیاریکراو",
    "tenants": "کرێچییەکان",
    "owners": "خاوەنەکان",
    "cancel": "هەڵوەشاندنەوە",
    "generating": "دروستکردن...",
    "generate_payments": "دروستکردنی پارەدانەکان",
    "search": "گەڕان",
    "search_by_tenant_name_or_phone": "گەڕان بە ناوی کرێچی، ژمارە تەلەفۆن یان ژمارەی پێشانگا...",
    "search_by_owner_name_or_phone": "گەڕان بە ناوی خاوەن یان ژمارە تەلەفۆن...",
    "no_results_found": "هیچ ئەنجامێک نەدۆزرایەوە",
    "selected": "دیاریکراو",
    "done": "تەواو",
    "no_tenants_available": "هیچ کرێچییەک بەردەست نییە. تکایە سەرەتا کرێچی زیاد بکە.",
    "no_owners_available": "هیچ خاوەنێک بەردەست نییە. تکایە سەرەتا خاوەن زیاد بکە.",
    "apt": "پێشانگا",
    "january": "کانوونی دووەم",
    "february": "شوبات",
    "march": "ئازار",
    "april": "نیسان",
    "may": "ئایار",
    "june": "حوزەیران",
    "july": "تەمموز",
    "august": "ئاب",
    "september": "ئەیلوول",
    "october": "تشرینی یەکەم",
    "november": "تشرینی دووەم",
    "december": "کانوونی یەکەم",
    "failed_to_load_buildings": "سەرکەوتوو نەبوو لە بارکردنی باڵەخانەکان. تکایە دووبارە هەوڵ بدەرەوە.",
    "failed_to_load_tenants": "سەرکەوتوو نەبوو لە بارکردنی کرێچییەکان. تکایە دووبارە هەوڵ بدەرەوە.",
    "failed_to_load_owners": "سەرکەوتوو نەبوو لە بارکردنی خاوەنەکان. تکایە دووبارە هەوڵ بدەرەوە.",
    "please_select_building": "تکایە باڵەخانەیەک هەڵبژێرە",
    "please_select_at_least_one_recipient": "تکایە لانی کەم یەک {{recipient}} هەڵبژێرە",
    "please_enter_valid_amount": "تکایە بڕێکی دروست داخل بکە",
    "please_select_month": "تکایە مانگێک هەڵبژێرە",
    "please_select_at_least_one_month": "تکایە لانی کەم یەک مانگ هەڵبژێرە",
    "end_month_must_be_after_start_month": "مانگی کۆتایی دەبێت دوای مانگی دەستپێک بێت",
    "successfully_generated_payments": "بە سەرکەوتوویی {{count}} پارەدانی خزمەتگوزاری دروستکرا بۆ {{months}} مانگ. {{skipped}} پارەدان پێشتر دروستکرابوون.",
    "failed_to_generate_service_payments": "سەرکەوتوو نەبوو لە دروستکردنی پارەدانەکانی خزمەتگوزاری",
    "tenant": "کرێچی",
    "owner": "خاوەن",

    "service_payment_statistics": "ئاماری پارەدانی خزمەتگوزاری",
    "back_to_services": "گەڕانەوە بۆ خزمەتگوزاریەکان",
    "building": "باڵەخانە",
    "year": "ساڵ",
    "loading_statistics": "بارکردنی ئامارەکان...",
    "no_building_selected": "هیچ باڵەخانەیەک دیاری نەکراوە",
    "please_select_building_statistics": "تکایە باڵەخانەیەک دیاری بکە بۆ بینینی ئاماری پارەدانی خزمەتگوزاری.",
    "overall_statistics": "ئاماری گشتی",
    "total_collection": "کۆی کۆکراوە",
    "of": "لە",
    "payment_rate": "ڕێژەی پارەدان",
    "payments": "پارەدانەکان",
    "outstanding_amount": "بڕی ماوە",
    "unpaid_payments": "پارەدانی نەدراو",
    "monthly_statistics": "ئاماری مانگانە",
    "no_monthly_data": "هیچ داتایەکی مانگانە بەردەست نییە بۆ ساڵی دیاریکراو.",
    "month": "مانگ",
    "total_amount": "کۆی بڕ",
    "collected": "کۆکراوە",
    "outstanding": "ماوە",
    "progress": "پێشکەوتن",
    "failed_to_load_service_statistics": "سەرکەوتوو نەبوو لە بارکردنی ئاماری خزمەتگوزاری",

    "loading_tenant_data": "بارکردنی زانیاریەکانی کرێچی...",
    "error_loading_tenant": "هەڵە لە بارکردنی کرێچی",
    "tenant_not_found": "کرێچی نەدۆزرایەوە",
    "back_to_tenants": "گەڕانەوە بۆ کرێچییەکان",
    "record_payment": "تۆمارکردنی پارەدان",
    "edit": "دەستکاری",
    "status_unknown": "دۆخ نەزانراوە",
    "apartment": "پێشانگا",
    "apt": "پێشانگا",
    "none": "هیچ",
    "monthly_rent": "کرێی مانگانە",
    "payment_date": "بەرواری پارەدان",
    "overview": "پوختە",
    "leases": "گرێبەستەکان",
    "payments": "پارەدانەکان",
    "contact_information": "زانیاری پەیوەندی",
    "lease_information": "زانیاری گرێبەست",
    "contract_period": "ماوەی گرێبەست",
    "rent": "کرێ",
    "discount": "داشکاندن",
    "rent_after_discount": "کرێ دوای داشکاندن",
    "additional_fees": "پارەدانی زیادە",
    "service_fee": "کرێی خزمەتگوزاری",
    "office_commission": "کومیسیۆنی نووسینگە",
    "insurance": "بیمە",
    "notes": "تێبینییەکان",
    "no_leases": "هیچ گرێبەستێک نییە",
    "no_leases_message": "ئەم کرێچییە هێشتا هیچ پێشانگایەکی بۆ دیاری نەکراوە.",
    "active_leases": "گرێبەستە چالاکەکان",
    "inactive_leases": "گرێبەستە ناچالاکەکان",
    "active": "چالاک",
    "ended": "کۆتایی هاتووە",
    "expiring_soon": "بەزوویی کۆتایی دێت",
    "end_lease": "کۆتایی هێنان بە گرێبەست",
    "start_date": "بەرواری دەستپێک",
    "end_date": "بەرواری کۆتایی",
    "duration": "ماوە",
    "remaining": "ماوەی ماوە",
    "months": "مانگ",
    "security_deposit": "بارمتەی دڵنیایی",
    "total_value": "بەهای گشتی",
    "no_payments": "هیچ پارەدانێک نییە",
    "no_payments_message": "ئەم کرێچییە هێشتا هیچ پارەدانێکی تۆمار نەکراوە.",
    "record_first_payment": "تۆمارکردنی یەکەم پارەدان",
    "payment_period": "ماوەی پارەدان",
    "reference": "ژمارەی پسوولە",
    "payment_type": "جۆری پارەدان",
    "rent_payment": "پارەدانی کرێ",
    "additional_fee": "پارەدانی زیادە",
    "utility_payment": "پارەدانی خزمەتگوزاری",
    "other_payment": "پارەدانی تر",
    "start": "دەستپێک",
    "end": "کۆتایی",
    "reference_number": "ژمارەی پسوولە",
    "cancel": "هەڵوەشاندنەوە",
    "unknown_period": "ماوەی نەزانراو",
    "invalid_period_format": "فۆرماتی ماوە نادروستە",
    "to": "بۆ",
    "invalid_period_data": "داتای ماوە نادروستە",
    "please_enter_valid_payment_amount": "تکایە بڕێکی پارەدانی دروست داخل بکە",
    "end_date_must_be_after_start_date": "بەرواری کۆتایی دەبێت دوای بەرواری دەستپێک بێت",
    "failed_to_add_payment": "سەرکەوتوو نەبوو لە زیادکردنی پارەدان",
    "maintenance_requests_not_supported": "داواکاریەکانی چاکسازی لە پێکهاتەی ئێستای داتابەیسدا پشتگیری ناکرێن",
    "failed_to_create_maintenance_request": "سەرکەوتوو نەبوو لە دروستکردنی داواکاری چاکسازی",
    "confirm_end_lease": "دڵنیایت کە دەتەوێت کۆتایی بەم گرێبەستە بهێنیت؟ ئەم کردارە ناتوانرێت پاشگەز بکرێتەوە.",
    "lease_ended_by_administrator": "گرێبەست لەلایەن بەڕێوەبەرەوە کۆتایی پێهێنرا",
    "failed_to_end_lease": "سەرکەوتوو نەبوو لە کۆتایی هێنان بە گرێبەست",
    "failed_to_load_tenant_data": "سەرکەوتوو نەبوو لە بارکردنی زانیاری کرێچی",
    "actual_end_date": "بەرواری کۆتایی ڕاستەقینە",
    "deposit": "بارمتە",


    "edit_tenant": "دەستکاریکردنی کرێچی",
    "add_tenant": "زیادکردنی کرێچی",
    "basic_information": "زانیاری بنەڕەتی",
    "first_name": "ناوی یەکەم",
    "last_name": "ناوی دوایی",
    "email": "ئیمەیل",
    "phone": "تەلەفۆن",
    "apartment": "پێشانگا",
    "select_apartment": "پێشانگا هەڵبژێرە",
    "floor": "قات",
    "rent_amount": "بڕی کرێ",
    "discount": "داشکاندن",
    "service_fee": "کرێی خزمەتگوزاری",
    "office_commission": "کومیسیۆنی نووسینگە",
    "insurance": "بیمە",
    "contract_start_date": "بەرواری دەستپێکی گرێبەست",
    "contract_end_date": "بەرواری کۆتایی گرێبەست",
    "payment_date": "بەرواری پارەدان",
    "payment_end_date": "بەرواری کۆتایی پارەدان",
    "rent_status": "دۆخی کرێ",
    "additional_information": "زانیاری زیاتر",
    "notes": "تێبینییەکان",
    "tenant_notes_placeholder": "هەر تێبینییەکی زیادە لەسەر ئەم کرێچییە...",
    "cancel": "هەڵوەشاندنەوە",
    "saving": "پاشەکەوتکردن...",
    "update_tenant": "نوێکردنەوەی کرێچی",
    "create_tenant": "دروستکردنی کرێچی",
    "loading": "بارکردن...",
    "failed_to_load_tenant_data": "سەرکەوتوو نەبوو لە بارکردنی زانیاری کرێچی",
    "failed_to_save_tenant": "سەرکەوتوو نەبوو لە پاشەکەوتکردنی کرێچی",
    "pending": "چاوەڕوان",
    "paid": "پارەدراو",
    "late": "درەنگ",
    "overdue": "دواکەوتوو",
    "unpaid": "پارەنەدراو",

    "tenants": "کرێچییەکان",
    "refresh_tenants": "نوێکردنەوەی کرێچییەکان",
    "selected": "هەڵبژێردراو",
    "delete_selected_tenants": "سڕینەوەی کرێچییە هەڵبژێردراوەکان",
    "search_tenants": "گەڕان بۆ کرێچییەکان...",
    "filter": "فلتەرکردن",
    "switch_to_list_view": "گۆڕین بۆ پیشاندانی لیست",
    "switch_to_grid_view": "گۆڕین بۆ پیشاندانی تۆڕ",
    "list_view": "لیست",
    "grid_view": "تۆڕ",
    "hide_inactive_tenants": "شاردنەوەی کرێچییە ناچالاکەکان",
    "show_inactive_tenants": "پیشاندانی کرێچییە ناچالاکەکان",
    "hide_inactive": "شاردنەوەی ناچالاکەکان",
    "show_inactive": "پیشاندانی ناچالاکەکان",
    "add_tenant": "زیادکردنی کرێچی",
    "rent_status": "دۆخی کرێ",
    "all_statuses": "هەموو دۆخەکان",
    "all_buildings": "هەموو باڵەخانەکان",
    "all_apartments": "هەموو پێشانگاکان",
    "min_rent": "کەمترین کرێ",
    "max_rent": "زۆرترین کرێ",
    "unlimited": "بێ سنوور",
    "contracts_ending_before": "گرێبەستەکان کۆتاییان دێت پێش",
    "clear_filters": "سڕینەوەی فلتەرەکان",
    "apply_filters": "جێبەجێکردنی فلتەرەکان",
    "active_tenants": "کرێچییە چالاکەکان",
    "inactive_tenants": "کرێچییە ناچالاکەکان",
    "with_apartments": "لەگەڵ یەکەی پێشانگا",
    "without_apartments": "بێ یەکەی پێشانگا",
    "tenants_management": "بەرێوەبردنی کرێچییەکان",
    "manage_tenants_and_leases": "بەرێوەبردنی کرێچییەکان و گرێبەستەکان",
    "add_tenant": "زیادکردنی کرێچی",
    "search_tenants_placeholder": "گەڕان بەدوای کرێچی بەپێی ناو، مۆبایل، یان یەکەی پێشانگا",
    "loading_tenants": "بارکردنی کرێچییەکان...",
    "error_loading_tenants": "هەڵە لە بارکردنی کرێچییەکان",
    "try_again": "هەوڵ بدەرەوە",
    "no_tenants_found": "هیچ کرێچییەک نەدۆزرایەوە",
    "no_tenants_message": "هیچ کرێچییەک لە سیستەمدا نییە. کلیک لەسەر دوگمەی 'زیادکردنی کرێچی' بکە بۆ دروستکردنی یەکەم کرێچی.",
    "create_first_tenant": "دروستکردنی یەکەم کرێچی",
    "page": "لاپەڕە",
    "showing_items": "پیشاندان {start}-{end} لە {total}",
    "first_page": "یەکەم لاپەڕە",
    "previous_page": "لاپەڕەی پێشوو",
    "next_page": "لاپەڕەی داهاتوو",
    "last_page": "دوا لاپەڕە",
    "showing_filtered_results": "پیشاندانی {showing} لە {total} کرێچی",
    "confirm_deletion": "دڵنیابوونەوە لە سڕینەوە",
    "delete_tenant_confirmation": "دڵنیایت کە دەتەوێت کرێچی \"{name}\" بسڕیتەوە؟ ئەم کردارە ناتوانرێت پاشەکشە بکرێت.",
    "cancel": "هەڵوەشاندنەوە",
    "deleting": "سڕینەوە...",
    "delete": "سڕینەوە",
    "tenant": "کرێچی",
    "apartment": "پێشانگا",
    "rent": "کرێ",
    "contract": "گرێبەست",
    "status": "دۆخ",
    "actions": "کردارەکان",
    "apt": "پێشانگا",
    "unknown_building": "باڵەخانەی نەناسراو",
    "no_apartment_assigned": "هیچ پێشانگایەک دیاری نەکراوە",
    "status_unknown": "دۆخی نەناسراو",
    "monthly_rent": "کرێی مانگانە",
    "after_discount": "دوای داشکاندن",
    "payment_date": "بەرواری پارەدان",
    "not_set": "دیاری نەکراوە",
    "contract_start": "دەستپێکی گرێبەست",
    "contract_end": "کۆتایی گرێبەست",
    "service": "خزمەتگوزاری",
    "commission": "کومیسیۆن",
    "insurance": "بیمە",
    "hide_owner_details": "شاردنەوەی وردەکاری خاوەن",
    "show_owner_details": "پیشاندانی وردەکاری خاوەن",
    "apartment_owner": "خاوەنی پێشانگا",
    "loading_owner_details": "بارکردنی وردەکاری خاوەن...",
    "no_owner_information": "هیچ زانیاریەک لەسەر خاوەن نییە",
    "lives_on_property": "لەوێ کار دەکات",
    "monthly_service_fee_applies": "خزمەتگوزاری مانگانە بۆی جێبەجێ دەکرێت",
    "yes": "بەڵێ",
    "no": "نەخێر",
    "total_apartments": "کۆی پێشانگاکان",
    "apartment_details": "وردەکاریەکانی پێشانگا",
    "apartment_number": "ژمارەی پێشانگا",
    "unknown": "نەزانراو",
    "floor": "قات",
    "apartment_type": "جۆری پێشانگا",
    "standard": "ستاندارد",
    "furnished": "موبیلیا",
    "view_owner_profile": "بینینی پرۆفایلی خاوەن",
    "mark_as_inactive": "دیاریکردن وەک ناچالاک",
    "mark_as_active": "دیاریکردن وەک چالاک",
    "record_payment": "تۆمارکردنی پارەدان",
    "view_details": "بینینی وردەکاریەکان",
    "edit_tenant": "دەستکاریکردنی کرێچی",
    "delete_tenant": "سڕینەوەی کرێچی",
    "to": "بۆ",
    "payment": "پارەدان",
    "apartment_financial_details": "وردەکاری داراییەکانی پێشانگا",
    "not_authenticated": "ڕێگەپێدراو نیت. تکایە چوونەژوورەوە تۆمار بکە.",
    "authentication_required": "ناسنامە پێویستە",
    "authentication_failed": "ناسنامە سەرکەوتوو نەبوو. تکایە دووبارە چوونەژوورەوە تۆمار بکە.",
    "access_denied": "ڕێگە نەدراوە. ڕۆڵی بەڕێوبەر پێویستە.",
    "server_error": "هەڵەی سێرڤەر. تکایە بزانە ئایا پشتەوەی سێرڤەر کار دەکات.",
    "cannot_connect_to_server": "ناتوانرێت پەیوەندی بە سێرڤەرەوە بکرێت. تکایە بزانە ئایا پشتەوەی سێرڤەر لەسەر پۆرتی 3000 کار دەکات.",
    "failed_to_load_tenants_data": "سەرکەوتوو نەبوو لە بارکردنی داتای کرێچییەکان",
    "unknown_error": "هەڵەی نەناسراو",
    "failed_to_delete_tenant": "سەرکەوتوو نەبوو لە سڕینەوەی کرێچی",
    "confirm_bulk_delete": "دڵنیایت کە دەتەوێت {count} کرێچی بسڕیتەوە؟ ئەم کردارە ناتوانرێت پاشەکشە بکرێت.",
    "failed_to_delete_tenants": "سەرکەوتوو نەبوو لە سڕینەوەی کرێچییەکان",
    "failed_to_update_tenant_status": "سەرکەوتوو نەبوو لە نوێکردنەوەی دۆخی کرێچی",
    "pending": "چاوەڕوان",
    "paid": "پارەدراو",
    "late": "درەنگ",
    "overdue": "دواکەوتوو",

    'add_new_user': 'بەکارهێنەری نوێ زیاد بکە',
    'search_users': 'گەڕان بەدوای بەکارهێنەران',
    'total_users': 'کۆی گشتی بەکارهێنەران',
    'active_users': 'بەکارهێنەرانی چالاک',
    'inactive_users': 'بەکارهێنەرانی ناچالاک',
    'financial_summary': 'پوختەی دارایی',
    'filters': 'فلتەرەکان',
    'search_tenant_by_name_phone_or_apartment': 'بەدوای کرێچیدا بگەڕێ بە ناوی تەلەفۆن یان پێشانگا',
    'view_profile': 'بینینی پڕۆفایلی',

    "generate": "زیاد بکە",
    "generated": "دروستکراوە",

    "generate_payment_for": "دروستکردنی پارەدان بۆ",
    "payment_amount": "بڕی پارەدان",
    "enter_amount": "بڕی پارە بنووسە",
    "mark_as_paid_immediately": "دەستبەجێ وەک پارەدراو دیاری بکە",
    "notes": "تێبینیەکان",
    "payment_notes": "تێبینی پارەدان",
    "required_fields": "خانە پێویستەکان",
    "cancel": "هەڵوەشاندنەوە",
    "generate_payment": "دروستکردنی پارەدان",

    // WhatsApp
    "whatsapp_settings": "ڕێکخستنەکانی واتساب",
    "whatsapp_settings_description": "ئاگادارکردنەوەی خۆکاری واتساب بۆ بەکارهێنەران و خاوەنەکان",
    "whatsapp_enable": "چالاككردنی ئاگادارکردنەوەکانی واتساب",
    "whatsapp_enable_sub": "هەموو پەیامە خۆکارییەکانی واتساب دابخە یان ببەستەرەوە",
    "general_settings": "ڕێکخستنە گشتییەکان",
    "default_country_code": "کۆدی وڵاتی بنەڕەت",
    "tenant_rent_reminder": "بیرهێنانەوەی کرێی بەکارهێنەر",
    "tenant_rent_reminder_sub": "ناردنی بیرهێنانەوە بۆ بەکارهێنەران پێش یان دوای ماوەی پارەدان",
    "days_before_due": "ڕۆژ پێش ماوەی سەرکەوتن",
    "reminder_message_template": "نموونەی پەیام",
    "service_fee_reminder": "بیرهێنانەوەی کرێی خزمەتگوزاری",
    "enable_service_fee_reminder": "چالاككردنی بیرهێنانەوەی کرێی خزمەتگوزاری",
    "service_fee_reminder_sub": "ئاگادارکردنەوەی بەکارهێنەران دەربارەی پارەدانی خزمەتگوزاری داهاتوو",
    "owner_reminder": "بیرهێنانەوەی خاوەن",
    "enable_owner_reminders": "چالاككردنی بیرهێنانەوەکانی خاوەن",
    "owner_reminder_sub": "ئاگادارکردنەوەی خاوەنان کاتێک بەکارهێنەرانیان پارەدانی دواخراو هەیە",
    "owner_message_template": "نموونەی پەیامی خاوەن",
    "payment_confirmation": "پشتڕاستکردنەوەی پارەدان",
    "send_on_payment": "ناردنی پشتڕاستکردنەوە کاتێک پارەدان تۆمار دەکرێت",
    "payment_confirmation_sub": "بە خۆکاری دەنێردرێت بۆ بەکارهێنەر کاتێک پارەدان تۆمار دەکرێت",
    "payment_confirmation_template": "نموونەی پەیامی پشتڕاستکردنەوە",
    "whatsapp_test_send": "ناردنی پەیامی تاقیکردنەوە",
    "test_message": "پەیام",
    "send_test_message": "ناردنی پەیامی تاقیکردنەوە",
    "whatsapp_test_sent": "پەیامی تاقیکردنەوە نێردرا!",
    "whatsapp_test_default_message": "پەیامی تاقیکردنەوە لە سیستەمی بەڕێوەبردنی موڵک",
    "send_reminders_now": "ئێستا بیرهێنانەوەکان بنێرە",
    "send_reminders_now_description": "یەکسەر بیرهێنانەوە بنێرە بۆ هەموو بەکارهێنەران و خاوەنانێک کە پێویستیان پێیەتی.",
    "whatsapp_must_be_enabled": "واتساب دەبێت پێشتر چالاک بکرێت",
    "failed_to_load_settings": "شکستی هێنا لە بارکردنی ڕێکخستنەکان",
    "settings_saved": "ڕێکخستنەکان بە سەرکەوتوویی پاشەکەوت کران",
    "failed_to_save": "شکستی هێنا لە پاشەکەوتکردن",
    "failed_to_send": "شکستی هێنا لە ناردن",
    "server_error": "هەڵەی پەیوەندی بە سێرڤەر",
    "sent": "نێردرا",
    "errors": "هەڵەکان",
    "skipped": "تێپەڕاندرا",

    // Bookings
    "bookings": "حجزەکان",
    "booking_management": "بەڕێوەبردنی حجز",
    "new_booking": "حجزی نوێ",
    "create_booking": "دروستکردنی حجز",
    "edit_booking": "دەستکاری حجز",
    "booking_details": "وردەکاری حجز",
    "prospect": "داواکاری ئەگەری",
    "prospect_name": "ناوی داواکار",
    "prospect_phone": "ژمارەی مۆبایل",
    "prospect_email": "ناونیشانی ئیمەیل",
    "move_in_date": "بەرواری گواستنەوە",
    "move_out_date": "بەرواری چوونەدەرەوە",
    "hold_duration": "ماوەی ڕاگرتن",
    "hold_hours": "کاتژمێرەکانی ڕاگرتن",
    "hold_expiration": "کۆتاییهاتنی ڕاگرتن",
    "internal_notes": "تێبینییە ناوخۆییەکان",
    "check_availability": "پشکنینی بەردەستبوون",
    "checking_availability": "پشکنین بۆ بەردەستبوون دەکرێت...",
    "no_bookings_found": "هیچ حجزێک نەدۆزرایەوە",
    "calendar_view": "بینینی ڕۆژژمێر",
    "waitlist": "لیستی چاوەڕوانی",
    "new_booking_hold": "ڕاگرتنی حجزی نوێ",
    "property_information": "زانیاری موڵک",
    "prospect_details": "وردەکاری داواکار",
    "requested_dates": "بەروارە داواکراوەکان",
    "conflict_detected": "تەنگژە دۆزرایەوە",
    "booking_timeline": "کاتی حجزەکان",
    "monthly_view_holds": "بینینی مانگانەی ڕاگرتنی یەکەی کەلەپووریە چالاکەکان",
    "confirmed_hold": "ڕاگرتنی پشتڕاستکراوە",
    "pending_payment": "پارەدانی چاوەڕوانکراو",
    "move_in": "گواستنەوە بۆ ناوەوە",
    "move_out": "گواستنەوە بۆ دەرەوە",
    "convert_to_tenant": "گۆڕین بۆ کرێچی",
    "confirm_booking": "پشتڕاستکردنەوەی حجز",
    "cancel_booking": "هەڵوەشاندنەوەی حجز",
    "booking_confirmed": "حجز پشتڕاستکرایەوە",
    "booking_cancelled": "حجز هەڵوەشێنرایەوە",
    "booking_converted": "بە سەرکەوتوویی حجز گۆڕدرا بۆ کرێچی!",
    "process_to_booking": "گۆڕین بۆ حجز",
    "waitlist_management": "بەڕێوەبردنی لیستی چاوەڕوانی",
    "waitlist_empty": "لیستی چاوەڕوانی بەتاڵە",
    "search_waitlist": "گەڕان لە لیستی چاوەڕوانی...",
    "priority": "لەپێشینە",
    "desired_unit": "یەکەی داواکراو",
    "move_in_preference": "بەرواری گونجاوی گواستنەوە",
    "added": "زیادکرا",
    "rank": "پلە",
    "process_waitlist_success": "بە سەرکەوتوویی گۆڕدرا بۆ حجزی چاوەڕوانکراو!",
    "remove_from_waitlist": "ئایا دڵنیایت لە سڕینەوەی ئەم ناوە لە لیستی چاوەڕوانی؟",
    "entry_removed": "ناو سڕایەوە",
    "hold_expires": "کۆتاییهاتنی ڕاگرتن",
    "hours": "کاتژمێر",
    "optional": "ئارەزوومەندانە",
    "apartment_element": "بەشی یەکەی کەلەپووری",
    "select_unit": "یەکەیەک هەڵبژێرە",
    "error_loading_data": "بارکردنی زانیارییەکان سەرکەوتوو نەبوو",
    "error_saving_booking": "هەڵە لە پاشەکەوتکردنی حجز",
    "save_changes": "پاشەکەوتکردنی گۆڕانکارییەکان",
    "select_apartment_move_in_date_error": "تکایە یەکەی کەلەپووری و بەرواری گواستنەوە هەڵبژێرە بۆ پشکنینی بەردەستبوون",
    "apartment_available": "یەکەی کەلەپووری بەردەستە بۆ ئەم بەروارانە!",
    "error_checking_availability": "هەڵە لە پشکنینی بەردەستبوون",
    "confirm_conflict_booking": "تەنگژەی بەروار هەیە. ئایا دڵنیایت لە بەردەوامبوون؟",
    "booking_updated": "حجز بە سەرکەوتوویی نوێکرایەوە",
    "booking_number": "حجز #{{id}}",
    "created_at": "دروستکراوە لە {{date}}",
    "created_by": "لە لایەن {{name}}",
    "system": "سیستەم",
    "confirm": "پشتڕاستکردنەوە",
    "target_property": "موڵکی مەبەست",
    "furnished": "مۆبیلیاتدار",
    "unfurnished": "بێ مۆبیلیات",
    "booking_window": "کات و ماوەی حجز",
    "indefinite": "بێ سنوور",
    "created_source": "دروستکراوە ({{source}})",
    "view_tenant_profile": "بڕوانە پڕۆفایلی کرێگرتە",
    "convert_to_active_tenant": "گۆڕین بۆ کرێنشینی چالاک",
    "lease_details_move_in_instruction": "تەواوکردنی وردەکارییەکانی بەکرێدان بۆ گواستنەوەی {{name}} بۆ ناو یەکەی {{unit}}.",
    "monthly_rent": "کرێی مانگانە",
    "first_payment_date": "بەرواری یەکەم پارەدان",
    "contract_start": "دەستپێکی گرێبەست",
    "contract_end": "کۆتایی گرێبەست",
    "confirm_convert": "پشتڕاستکردنەوە و گۆڕین",
    "confirm_booking_question": "ئایا دڵنیایت لە پشتڕاستکردنەوەی ئەم حجزە؟",
    "reason_optional": "تکایە هۆکارێک بنووسە (ئارەزوومەندانە):",
    "amount": "بڕ",
    "today": "ئەمڕۆ",
    "sun": "یەکشەممە",
    "mon": "دووشەممە",
    "tue": "سێشەممە",
    "wed": "چوارشەممە",
    "thu": "پێنجشەممە",
    "fri": "هەینی",
    "sat": "شەممە",
    "more": "زیاتر",
    "close": "داخستن",
    "hold_expiration": "کۆتاییهاتنی حجز",
    "view_details": "بڕوانە وردەکاریی",
    "waitlist_management": "بەڕێوەبردنی لیستی چاوەڕوانی",
    "search_waitlist": "گەڕان لە لیستی چاوەڕوانی...",
    "waitlist_empty": "لیستی چاوەڕوانی چۆڵە",
    "no_prospective_tenants_waiting": "لە ئێستادا هیچ کرێنشینێکی چاوەڕوانکراو چاوەڕێی بەردەستبوونی پێشانگا ناکات.",
    "priority": "گرنگی",
    "rank": "پلە: {{priority}}",
    "desired_unit": "یەکەی مەبەست",
    "move_in_preference": "پەسەندکراوی گواستنەوە",
    "process_to_booking": "چارەسەرکردن بۆ حجز",
    "remove": "سڕینەوە",
    "remove_waitlist_confirm": "ئایا دڵنیایت لە سڕینەوەی ئەم پێشنیارە لە لیستی چاوەڕوانی؟",
    "waitlist_processed": "بە سەرکەوتوویی گۆڕدرا بۆ حجزێکی چاوەڕوانکراو!",
    "entry_removed": "پێشنیار سڕایەوە",
    "failed_process_waitlist": "چارەسەرکردنی پێشنیاری لیستی چاوەڕوانی سەرکەوتوو نەبوو",
    "failed_remove_entry": "سڕینەوەی پێشنیار سەرکەوتوو نەبوو",
    "booking_analytics": "ئامارەکانی حجز",
    "track_conversion_and_holds": "بەدواداچوونی ڕێژەی گۆڕین و ماوەی ڕاگرتنەکان",
    "last_7_days": "٧ ڕۆژی ڕابردوو",
    "last_30_days": "٣٠ ڕۆژی ڕابردوو",
    "last_90_days": "٩٠ ڕۆژی ڕابردوو",
    "last_year": "ساڵی ڕابردوو",
    "total_bookings": "کۆی گشتی حجزەکان",
    "in_selected_period": "لە ماوەی دیاریکراودا",
    "conversion_rate": "ڕێژەی گۆڕین",
    "converted_to_tenants": "{{count}} گۆڕدرا بۆ کرێنشین",
    "cancellation_rate": "ڕێژەی هەڵوەشاندنەوە",
    "cancelled_holds": "{{count}} حجزی هەڵوەشاوە",
    "avg_hold_time": "تێکڕای کاتی ڕاگرتن",
    "before_conversion_cancel": "پێش گۆڕین/هەڵوەشاندنەوە",
    "volume_trends": "ئاراستەکانی قەبارە",
    "no_trend_data": "هیچ زانیارییەکی ئاراستە بەردەست نییە",
    "total_holds": "کۆی حجزەکان",
    "status_breakdown": "دابەشبوونی بارودۆخ",
    "no_status_data": "هیچ زانیارییەکی بارودۆخ بەردەست نییە",
    "active_holds": "حجزە چالاکەکان",
    "apartment_unit_display": "پێشانگای {{number}} - قاتی {{floor}}",
    "pending_move_in": "چاوەڕوانی گواستنەوە",
    "tenant_name": "ناو",
    "tenant_phone": "ژمارەی تەلەفۆن",
    "tenant_email": "ئیمەیل",
    "lease_details": "وردەکارییەکانی گرێبەست",
    "start_date": "بەرواری دەستپێکردن",
    "end_date": "بەرواری کۆتایی هاتن",
    "monthly_pay_date": "بەرواری پارەدانی مانگانە",
    "day_number": "ڕۆژی {{number}}",
    "duration": "ماوە",
    "months": "مانگ",
    "remaining_time": "کاتی ماوە",
    "financial_summary": "پوختەی دارایی",
    "monthly_rent": "کرێی مانگانە",
    "effective_rent": "کرێی ڕاستەقینە",
    "rent_status": "دۆخی کرێ",
    "future_tenant_upcoming_move_in": "کرێچی داهاتوو (گواستنەوەی داهاتوو)",
    "move_in_date": "بەرواری گواستنەوە",
    "contract_end": "کۆتایی گرێبەست",
    "recent_bookings": "حجزە نوێیەکان و ڕاگرتنەکان",
    "new_hold": "ڕاگرتنی نوێ",
    "available_now": "ئێستا بەردەستە",
    "lease_ending_soon": "کرێ بەم زووانە کۆتایی دێت",
    "no_apartments_found": "هیچ پێشانگایەکی گونجاو نەدۆزرایەوە",
    "ready": "ئامادەیە",
    "ends_in_days": "کۆتایی دێت لەماوەی {{count}} ڕۆژدا",
    "search_unit": "گەڕان بۆ پێشانگا...",
    "currently_occupied": "لە ئێستادا داگیرکراوە",
    "occupied": "داگیرکراوە",
    "all_service_payments": "هەموو پارەدانی خزمەتگوزاریەکان",
    'manage_all_service_payments_across_buildings': 'بەڕێوەبردنی هەموو پارەدانی خزمەتگوزاریەکان لە سەرانسەری کۆمپلێکسەکاندا',
    'tenants_management': 'بەڕێوەبردنی کرێنشینان',
    'manage_tenants_and_leases': 'بەڕێوەبردنی کرێنشینان و گرێبەستەکان',
    'past_tenants': 'کرێنشینانی پێشوو',
    'lease_ended': 'گرێبەست کۆتایی هاتوە',
    'end_lease_confirm_title': 'پشتڕاستکردنەوەی کۆتایی هاتنی گرێبەست',
    'end_lease_confirm_body': 'دڵنیایت لە کۆتایی هاتنی ئەم گرێبەستە؟',
    'no_past_tenants': 'هیچ کرێنشینێکی پێشوو نییە',
    'status_expired_description': 'ئەم گرێبەستە کۆتایی هاتوە. هیچ پارەیەکی تر ناتوانرێت بۆی جێبەجێ بکرێت.',
    'lease_expired_warning': 'ئەم گرێبەستە کۆتایی هاتوە.',
    'tenant_lease_expired_message': 'هیچ پارەیەکی تر ناتوانرێت بۆی جێبەجێ بکرێت.',
    'expired_on': 'کۆتایی هاتوە لە',
    'manage_tenant': 'بەڕێوەبردنی کرێنشین',
    'move_in_pending': 'گواستنەوەی چاوەڕوانکراو',
    'lease_expired': 'گرێبەست کۆتایی هاتوە',
    'create_hold': 'دروستکردنی ڕاگرتن',
    'billing_subscription': 'بڵینگ و بەشداری',
    'current_plan': 'پلانی ئێستا',
    'subscribe_now': 'سەبسکرایب بکە ئێستا',
    'manage_your_subscription_and_billing': 'بەڕێوەبردنی بەشداری و بڵینگی خۆت',
    'view_payment_logs': 'بینینی تۆماری پارەدانەکان',
    'view_activity_logs': 'بینینی تۆمارەکانی چالاکی',
    'view_revenue_report': 'بینینی ڕاپۆرتی داهات',
    'view_occupancy_report': 'بینینی ڕاپۆرتی نیشتەجێبوون',
    'view_tenant_logs': 'بینینی تۆماری کرێنشینان',
    'login_success': 'چوونەژوورەوە سەرکەوتوو بوو',
    'logout_success': 'چوونەدەرەوە سەرکەوتوو بوو',
    'record_payment': 'تۆمارکردنی پارەدان',
    'occupied_status': 'داگیرکراوە',
    'partial': 'جزئي',
    'scheduled_tenants': 'کرێنشینانی چاوەڕوانکراو',
    'multiple_leases': 'گرێبەستە فرەوانەکان',
    'current_end_date': 'بەرواری کۆتایی هاتنی ئێستا',
    'new_end_date': 'بەرواری کۆتایی هاتنی نوێ',
    'extend': 'درێژکردنەوە',
    'transfer': 'گواستنەوە',
    'transfer_apartment': 'گواستنەوەی پێشانگا',
    'current_apartment': 'پێشانگای ئێستا',
    "extend": "درێژکردنەوە",
    "transfer": "گواستنەوە",
    "transfer_apartment": "گواستنەوەی پێشانگا",
    "current_apartment": "پێشانگای ئێستا",
    "select_new_apartment": "دیاریکردنی پێشانگای نوێ",
    "new_monthly_rent": "کرێی مانگانەی نوێ",
    "transferring": "گواستنەوە...",
    "failed_to_transfer_tenant": "گواستنەوەی کرێنشین سەرکەوتوو نەبوو",
    "tenant_transferred_success": "کرێنشین بەسەرکەوتوویی گواسترایەوە",
    "expired": "کۆتایی هاتوە",

    // Sales Module
    "sales": "فرۆشتنەکان",
    "sale_list": "لیستی فرۆشتن",
    "new_sale": "فرۆشتنی نوێ",
    "record_new_sale": "تۆمارکردنی فرۆشتنی نوێ",
    "record_new_sale_subtitle": "دروستکردنی کڕیار، دیاریکردنی پێشانگا، و ڕێکخستنی پلانی پارەدان",
    "sales_subtitle": "بەڕێوەبردنی فرۆشتنی موڵک — کڕیار، پێشانگا، و پلانەکانی پارەدان",
    "total_sales": "کۆی فرۆشتنەکان",
    "outstanding_balance": "هاوسەنگی ماوە",
    "buyer": "کڕیار",
    "buyer_information": "زانیاری کڕیار",
    "buyer_name": "ناوی تەواو",
    "buyer_name_placeholder": "بۆ نموونە: ئەحمەد الراشید",
    "buyer_phone": "تەلەفۆن",
    "buyer_language": "زمانی پەسەندکراو",
    "select_apartment": "پێشانگایەک هەڵبژێرە",
    "select_apartment_required": "پێشانگایەک هەڵبژێرە *",
    "available_apartments_count": "{{count}} بەردەستە",
    "no_apartments_available_sale": "هیچ پێشانگایەک بەردەست نییە — هەموو پێشانگاکان خاوەنیان هەیە.",
    "payment_plan": "پلانی پارەدان",
    "full_payment": "پارەدانی تەواو",
    "installments_plan": "قیست",
    "total_sale_price": "نرخی فرۆشتنی گشتی (دۆلار)",
    "total_sale_price_placeholder": "بۆ نموونە: 75000",
    "payment_date_label": "بەرواری پارەدان",
    "first_payment_date": "بەرواری یەکەم قیست",
    "num_installments": "ژمارەی قیستەکان",
    "per_installment_hint": "≈ ${{amount}} / قیست • جەدوەلی مانگانە",
    "record_sale": "تۆمارکردنی فرۆشتن",
    "sale_recorded_success": "فرۆشتن بە سەرکەوتوویی تۆمارکرا!",
    "sale_deleted": "فرۆشتن سڕایەوە",
    "payment_recorded": "پارەدان تۆمارکرا",
    "no_sales_found": "هیچ فرۆشتنێک نەدۆزرایەوە",
    "record_first_sale": "یەکەم فرۆشتن تۆمار بکە",
    "sale_not_found": "فرۆشتن نەدۆزرایەوە",
    "delete_sale_confirm": "ئەم فرۆشتنە بسڕەرەوە؟ گرێبەست و پەیوەندی پێشانگاکە ناوبردەبێت.",
    "delete_sale_all_confirm": "هەموو ئەم فرۆشتنە بسڕرەرەوە؟ ناتوانرێت پاشگەز بکرێتەوە.",
    "sale_detail": "وردەکاری فرۆشتن",
    "sale_date": "بەرواری فرۆشتن",
    "financials": "دارایی",
    "collected": "کۆکراوە",
    "balance": "هاوسەنگی",
    "payment_progress": "پێشکەوتنی پارەدان",
    "installments": "قیستەکان",
    "due_date": "بەرواری سەرکەوتن",
    "mark_paid": "نیشانە بکە وەک پارەدراو",
    "confirm_payment": "پشتڕاستکردنەوە",
    "payment_date_label2": "بەرواری پارەدان:",
    "all_statuses": "هەموو دۆخەکان",
    "search_sales_placeholder": "گەڕان بۆ کڕیار، تەلەفۆن، پێشانگا...",
    "sale_progress": "پێشکەوتن",
    "sale_balance": "هاوسەنگی",
    "sale_paid": "پارەدراو",
    "sale_unpaid": "پارەنەدراو",
    "sale_partial": "جزئی",
    "notes_optional": "تێبینی (ئارەزوومەندانە)",
    "notes_placeholder": "هەر زانیارییەکی زیادە...",
    "failed_to_load_sales": "بارکردنی فرۆشتنەکان سەرکەوتوو نەبوو",
    "failed_to_delete_sale": "سڕینەوەی فرۆشتن سەرکەوتوو نەبوو",
    "failed_to_record_payment": "تۆمارکردنی پارەدان سەرکەوتوو نەبوو",
    "failed_to_load_sale": "بارکردنی فرۆشتن سەرکەوتوو نەبوو",
    "failed_to_create_sale": "دروستکردنی فرۆشتن سەرکەوتوو نەبوو",
    "buyer_name_required": "ناوی کڕیار پێویستە",
    "valid_phone_required": "ژمارەی تەلەفۆنی دروست پێویستە",
    "apartment_required_sale": "تکایە پێشانگایەک هەڵبژێرە",
    "valid_price_required": "نرخێکی دروست داخل بکە",
    "first_payment_date_required": "بەرواری یەکەم قیست پێویستە",
    "valid_installment_amounts_required": "بۆ هەر قیستێک بڕێکی دروست داخل بکە",
    "installment_amounts_must_match_total": "کۆی بڕەکانی قیستەکان دەبێت یەکسان بێت لەگەڵ نرخی گشتی فرۆشتن",
    "edit_installment_amounts": "بڕەکان بە دەست دەستکاری بکە",
    "total_allocated": "کۆی دابەشکراو",
    "remaining": "ماوە",
    "matches_total": "لەگەڵ نرخی گشتی یەکسانە",
    "mark_as_paid_now": "نیشانە بکە وەک پارەدراو ئێستا",
    "mark_as_paid_now_hint": "قیست/قیستەکان دەستبەجێ وەک پارەدراو نیشانە دەکرێن بە بەرواری ئەمڕۆ",
    "per_installment_paid_hint": "یەکەم قیست وەک پارەدراو نیشانە دەکرێت؛ ماوەکان وەک چاوەڕوان دادەنرێن",

    "rent_revenue": "داهاتی کرێ",
    "service_revenue": "داهاتی خزمەتگوزاری",
    "insurance_revenue": "داهاتی بیمە",
    "sale_revenue": "داهاتی فرۆشتن",

    "sale_has_commission": "کۆمپانیای خانووبەرە کۆمیشنێک وەردەگرێت لەسەر ئەم فرۆشتنە",
    "commission": "کۆمیشن",
    "commission_percent": "% لە نرخ",
    "commission_fixed_amount": "بڕی جێگیر",
    "commission_rate": "ڕێژەی کۆمیشن",
    "commission_amount": "بڕی کۆمیشن",
    "commission_notes": "تێبینی کۆمیشن (ئارەزوومەندانە)",
    "commission_notes_placeholder": "بۆ نموونە: ناوی ئاژانس / هۆکار",
    "commission_deducted_label": "کۆمیشنی کەمکراوە لەم فرۆشتنە",
    "net_to_company": "بەخاڵیس بۆ کۆمپانیا",
    "valid_commission_rate_required": "ڕێژەی کۆمیشن دەبێت لە نێوان 0 و 100 بێت",
    "valid_commission_amount_required": "بڕی کۆمیشن دەبێت ژمارەیەکی دروست و نەرێنی نەبێت",
    "commission_exceeds_price": "بڕی کۆمیشن ناتوانێت لە نرخی گشتی فرۆشتن زیاتر بێت",
    "total_commission_paid": "کۆمیشنی دراو",
    "sale_commission_expense": "کۆمیشنی فرۆشتن دراو",
    "sale_commission_expense_hint": "کەمکراوەتەوە بۆ کۆمیشنی ئاژانسی خانووبەرە لەسەر فرۆشتنی یەکەکان لەم ماوەیەدا — لە داهاتی فرۆشتن لای سەرەوە کەم ناکرێتەوە.",
    "net_revenue_after_commission": "داهاتی خاڵیس (دوای کۆمیشن)",
    "net_revenue_after_commission_hint": "کۆی داهات کەم کراوە لێی کۆمیشنی فرۆشتنی دراو. تێناگرێت خەرجی تر (چاکسازی، مووچە، هتد) — لەم سیستەمە بەدواداچوون بۆ ناکرێت هێشتا.",


    'update_complex_desc': 'نوێکردنەوەی وردەکارییە پێکهاتەییەکانی ئەم کۆمەڵگەیە.',
    'define_complex_desc': 'شوێن و توانای کۆمەڵگە لۆجستییە نوێیەکەت دیاری بکە.',
    'used_for_mapping_desc': 'بۆ نەخشەسازی و دروستکردنی ڕاپۆرتی فەرمی بەکاردێت.',
    'how_many_blocks_desc': 'ئەم پارکە چەند بلۆک یان ڕیزی جیاوازی هەیە؟',
    'm2_free': 'م² بەردەست',
    'utilization': 'بەکارهێنان',
    'overdue_payments': 'پارەدانی دواکەوتوو',
    'all_payments_current': 'هەموو پارەدانەکان لەکاتی خۆیدایە',
    'm2_total_area': 'ڕووبەری گشتی م²',
    'type_small': 'بچووک',
    'type_medium': 'مامناوەند',
    'type_large': 'گەورە',
    'type_extra_large': 'زۆر گەورە',
    'type_cold_storage': 'کۆگای سارد',
    'type_drive-in': 'شۆفێری بۆ ناوەوە',
    'zone': 'ناوچە',
    'units': 'یەکەکان',
    'front': 'پێشەوە',
    'back': 'دواوە',
    'side': 'لایەنی',
    'back_row': 'ڕیزی دواوە',
    'front_row': 'ڕیزی پێشەوە',
    'wall': 'دیوار',

    // ── Service Management ──────────────────────────────────────────
    'service_payments_management': 'بەڕێوەبردنی کرێی خزمەتگوزاری',
    'service_payments_for_building_year': 'کرێی خزمەتگوزاری بۆ {{building}} — {{year}}',
    'back_to_dashboard': 'گەڕانەوە بۆ داشبۆرد',
    'refresh': 'نوێکردنەوە',
    'data_refreshed_successfully': 'داتاکان بە سەرکەوتوویی نوێکرانەوە',
    'failed_to_refresh_data': 'شکستی هێنا لە نوێکردنەوەی داتاکان',
    'loading_service_data': 'بارکردنی داتای خزمەتگوزاری...',
    'select_building': 'کۆمپلێکسێک دیاری بکە',
    'no_building_selected': 'هیچ کۆمپلێکسێک دیاری نەکراوە',
    'please_select_building': 'تکایە کۆمپلێکسێک دیاری بکە بۆ بینینی کرێی خزمەتگوزاری.',
    'no_floors_available': 'هیچ نهۆمێک بەردەست نییە',
    'no_floors_message': 'هیچ نهۆمێک لەگەڵ پێشانگاکان لەم کۆمپلێکسەدا نییە، یان کرێی خزمەتگوزاری تاکو ئێستا دروست نەکراوە.',
    'failed_to_load_buildings': 'شکستی هێنا لە بارکردنی کۆمپلێکسەکان',
    'failed_to_load_floors': 'شکستی هێنا لە بارکردنی نهۆمەکان',
    'failed_to_load_floor_data': 'شکستی هێنا لە بارکردنی داتای نهۆم',
    'failed_to_load_building_floors': 'شکستی هێنا لە بارکردنی نهۆمەکانی کۆمپلێکس',
    'no_apartments_on_floor': 'هیچ پێشانگایەک لەم نهۆمەدا نەدۆزرایەوە.',
    'no_matching_apartments': 'هیچ پێشانگایەک لەگەڵ گەڕانەکەت ناگونجێت.',
    'no_search_results': 'هیچ ئەنجامێک لەگەڵ گەڕانەکەت ناگونجێت.',
    'filter_by_status': 'فلتەرکردن بەپێی بارودۆخ',
    'search_apartments_tenants': 'گەڕان لە یەکەکان، خاوەن، کرێچی...',
    'view_statistics': 'بینینی ئامارەکان',
    'summary': 'کورتە',
    'zone_showroom_count': 'زۆن {{zone}} — {{count}} یەکە',
    'generate_payment': 'دروستکردنی پارەدان',
    'generate_payment_for': 'دروستکردنی پارەدان بۆ پێشانگای {{number}}',
    'payment_amount': 'بڕی پارەدان',
    'enter_amount': 'بڕ داخل بکە',
    'invalid_amount': 'تکایە بڕێکی دروست کە زیاتر لە 0ە داخل بکە',
    'mark_as_paid_immediately': 'وەک دراو نیشان بدە ئێستا',
    'payment_notes': 'تێبینی پارەدان',
    'required_fields': 'خانە پێویستەکان',
    'payment_generated_successfully': 'پارەدان بە سەرکەوتوویی دروست کرا',
    'failed_to_generate_payment': 'شکستی هێنا لە دروستکردنی پارەدان',
    'failed_to_update_payment': 'شکستی هێنا لە نوێکردنەوەی پارەدان',
    'payment_marked_as_paid': 'پارەدان وەک دراو نیشانکرا',
    'payment_marked_as_unpaid': 'پارەدان وەک نەدراو نیشانکرا',
    'marked_as_paid_via_service_management': 'لە ڕێگەی بەڕێوەبردنی خزمەتگوزاری وەک دراو نیشانکرا',
    'marked_as_unpaid_via_service_management': 'لە ڕێگەی بەڕێوەبردنی خزمەتگوزاری وەک نەدراو نیشانکرا',
    'payment_details': 'وردەکاری پارەدان',
    'payment_due': 'پارەدانی دەسکەوتوو',
    'paid_on': 'دراوە لە {{date}}',
    'rate': 'نرخ',
    'unpaid': 'نەدراو',

    // ── Building View ───────────────────────────────────────────────
    'edit_complex': 'دەستکاریکردنی کۆمپلێکس',
    'attention_required': 'سەرنجدان پێویستە',
    'overdue_payment': 'پارەدانی دواکەوتوو',
    'available': 'بەردەستە',
    'vacant_available': 'بەتاڵ / بەردەستە',
    'corner': 'گۆشە',

    // ── Owner Form / Sale Form ──────────────────────────────────────
    'failed_to_load_data': 'شکستی هێنا لە بارکردنی داتاکان',
    'failed_to_save_owner': 'شکستی هێنا لە پاشەکەوتکردنی خاوەن',
    'lives_on_property': 'لە موڵکەکەدا دەژیێت',
    'monthly_service_fee_applies': 'کرێی خزمەتگوزاری مانگانە دەمرێت',
    'works_at_showroom': 'کڕیار لەم پێشانگایەدا کاردەکات',
    'change': 'گۆڕین',

    // ── 2FA / OTP ───────────────────────────────────────────────────
    'otp_security_verification': 'پشتڕاستکردنەوەی ئەمنی',
    'otp_enter_code_whatsapp': 'تکایە کۆدی پشتڕاستکردنەوەی ناردراو بۆ واتساپەکەت داخل بکە.',
    'otp_verification_code': 'کۆدی پشتڕاستکردنەوە',
    'otp_check_whatsapp': 'واتساپەکەت بپشکنە بۆ کۆدەکە',
    'otp_invalid_code': 'تکایە کۆدی پشتڕاستکردنەوەی دروست داخل بکە',
    'otp_resent': 'کۆدی پشتڕاستکردنەوە دووبارە نێردرا بۆ واتساپەکەت',
    'otp_verify_code': 'پشتڕاستکردنەوەی کۆد',
    'otp_verifying': 'پشتڕاستکردنەوە...',
    'otp_resend_code': 'دووبارە ناردنی کۆد',
    'otp_back_to_login': 'گەڕانەوە بۆ چوونەژوورەوە',
  }
};